import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const Categories = () => {
  const navigate = useNavigate();

  //Categoria Otros
  /* const [linkOtros, setLinkOtros] = useState("");
  const handleClickOtros = (e) => {
    setLinkOtros("/category/otros");
    e.target.parentNode.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/otros");
    }, 1500);
  }; */

  //Categoria Portatucas
  const [linkPortatucas, setLinkPortatucas] = useState("");
  const handleClickPortatucas = (e) => {
    setLinkPortatucas("/category/portatucas");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/portatucas");
    }, 1500);
  };

  //Categoria Filtros
  const [linkFiltros, setLinkFiltros] = useState("");
  const handleClickFiltros = (e) => {
    setLinkFiltros("/category/filtros");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/filtros");
    }, 1500);
  };

  //Categoria Pikas
  const [linkPikas, setLinkPikas] = useState("");
  const handleClickPikas = (e) => {
    setLinkPikas("/category/pikas");
    e.target.parentNode.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/pikas");
    }, 1500);
  };

  //Categoria Sedas
  const [linkSedas, setLinkSedas] = useState("");
  const handleClickSedas = (e) => {
    setLinkSedas("/category/sedas");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/sedas");
    }, 1500);
  };

  //Categoria Cogolleros
  const [linkCogolleros, setLinkCogolleros] = useState("");
  const handleClickCogolleros = (e) => {
    setLinkCogolleros("/category/cogolleros");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/cogolleros");
    }, 1500);
  };

  //Categoria Fuegos
  const [linkFuegos, setLinkFuegos] = useState("");
  const handleClickFuegos = (e) => {
    setLinkFuegos("/category/fuegos");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/fuegos");
    }, 1500);
  };

  //Categoria Llaveros
  const [linkLlaveros, setLinkLlaveros] = useState("");
  const handleClickLlaveros = (e) => {
    setLinkLlaveros("/category/llaveros");
    e.target.parentNode.setAttribute("class", "verde");
    setTimeout(() => {
      navigate("/category/llaveros");
    }, 1500);
  };

  useEffect(() => {
    const cogollos = document.getElementById("bandeja");
    setTimeout(() => {
      cogollos.setAttribute("class", "verde");
    }, 1000);
    setTimeout(() => {
      cogollos.setAttribute("class", "cogollos");
    }, 2000);
    setTimeout(() => {
      cogollos.setAttribute("class", "verde");
    }, 3000);
    setTimeout(() => {
      cogollos.setAttribute("class", "cogollos");
    }, 4000);
    setTimeout(() => {
      cogollos.setAttribute("class", "verde");
    }, 5000);
    setTimeout(() => {
      cogollos.setAttribute("class", "violet-final");
    }, 6000);
  }, []);

  return (
    <div className="categories my-4">
      <h2>¿QUÉ ESTÁS BUSCANDO?</h2>
      <p>Clickeá en la categoría de productos que querés ver</p>
      <svg x="0px" y="0px" viewBox="0 0 1920 1080">
        <g className="bandeja" id="bandeja">
          <path
            class="violet"
            d="M1680.63,904.93h-1428c0,0-216,5-163-167l184-337c0,0,44-81,194-92H1440c0,0,152.63-11,222.63,116l158,289
		C1820.63,713.93,1876.63,891.93,1680.63,904.93z"
          />
          <path
            class="violet"
            d="M1869.13,685.43l-163-275c0,0-76-111-250-121H491.88c0,0-192.75,10-274.75,126l-184,314
		c0,0-9.9,22.99-13,54.92c0,0.03,0,0.05-0.01,0.08c-6.35,65.91,16.34,169.82,215.01,188h1372c0,0,178,2,249-59
		c27.2-23.37,40.75-50.85,45.1-80.24C1908.22,785.86,1891.34,733.55,1869.13,685.43z M1680.63,904.93h-1428c0,0-216,5-163-167
		l184-337c0,0,44-81,194-92H1440c0,0,152.63-11,222.63,116l158,289C1820.63,713.93,1876.63,891.93,1680.63,904.93z"
          />
          <path
            class="violet"
            d="M89.63,737.93l184-337c0,0,44-81,194-92H1440c0,0,152.63-11,222.63,116l158,289c0,0,56,178-140,191h-1428
		C252.63,904.93,36.63,909.93,89.63,737.93z"
          />
          <path
            class="violet"
            d="M1901.23,833.19c-2.87,32.58-16.29,63.13-46.1,88.74c-71,61-249,59-249,59h-1372
		C26.69,961.94,11.1,849.5,20.12,784.43c-6.35,65.91,16.34,169.82,215.01,188h1372c0,0,178,2,249-59
		C1883.33,890.06,1896.88,862.58,1901.23,833.19z"
          />
          <path
            class="violet"
            d="M1680.63,904.93h-1428c0,0-216,5-163-167l184-337c0,0,44-81,194-92H1440c0,0,152.63-11,222.63,116l158,289
		C1820.63,713.93,1876.63,891.93,1680.63,904.93z"
          />
          <path
            class="violet"
            d="M511.63,437.93h971c0,0,87,4,117,88l88,240c0,0,50.69,101.51-93.65,116.75H282.63c0,0-112-16.75-52-124.75
		s136-248,136-248S397.63,433.93,511.63,437.93z"
          />
        </g>
        {/* <Link to={linkOtros} onClick={handleClickOtros}> */}
        <g className="cogollos" /*  id="cogollos" */>
          <g>
            <path
              class="green"
              d="M952.85,781.59c-0.69-0.34-1.44-0.64-2.25-0.91c-0.02-0.96-0.07-2.14-0.22-3.46
    c-0.63-5.46-2.87-13.23-10.26-16.72c-7.2-3.39-12.87-1.3-16.54,2.4c-4.19-3.02-12.64-7.22-21.02-0.3
    c-1.19,0.98-2.39,2.2-3.57,3.67c-4.5-0.82-10.81-2.05-10.15-2.38c1.01-0.5,2.76-3.07,0.85-4.06c-3.72-0.02-9.99,1.2-12.3,9.17
    c-6.49-3.89-16.73-7.19-20.92,7.13c-4.66-0.1-11.28,0.87-13.82,6.68c-3.36,7.7,1.43,13.06,6.07,14.74
    c-0.14,1.51-0.11,3.42,0.51,5.3c0.12-1.17,1.68-1.52,1.52-0.77c-0.24,1.08,6.43,3.33,5.98,1.3c-0.33-1.5,7.37,3.45,11.47,6.17
    c-0.58,0.82-1.22,1.84-1.79,3.02c-0.97,1.95-1.75,4.32-1.83,6.94c-0.11,3.41,1.01,7.23,4.54,11.01
    c8.24,8.82,17.11,6.45,20.86,4.84c1.3,4.27,4.08,8.56,9.93,10.07c3.59-0.92,7.91-2,10.74-2.64l0.06-0.09
    c0.03,0.02,0.06,0.04,0.09,0.05c-0.06,0.01-0.1,0.03-0.15,0.04l-7.74,10.28c2.98,3.36,10.98,10.2,21.45,1.83
    c1.98,1.95,5.09,3.36,9.95,2.95c11.73-1,15.19-11.83,11.99-20.57c2.65-1.4,5.03-3.85,6.22-8.07c0.31-1.09,0.47-2.11,0.53-3.08
    c0.18-3.26-0.98-5.77-2.65-7.69h-0.01c-0.13-0.17-0.27-0.33-0.42-0.48c0.25-0.83,0.39-1.75,0.32-2.76
    c-0.04-0.6-0.16-1.23-0.39-1.88c-0.12-0.37-0.28-0.74-0.47-1.12c-0.2-0.4-0.44-0.79-0.72-1.2c-0.23-0.33-0.47-0.62-0.72-0.88
    c1.73-3.2,7.68-9.34,9.63-11.58c2.3-2.63,0.85,2.28-0.55,4.02c0.5-0.59,1.57-1.91,2.86-3.47
    C961.06,793.44,960.93,785.43,952.85,781.59z M880.43,787.61c-3.84-3.47-9.03-5.55-9.03-5.55s2.06,0.28,2.27-0.69
    c0.2-0.95-4.49-6.62-4.78-6.98l4.71,2.42l0.47-2.16l4.31,5.69c1.16-1.06,2.9,2.12,4.01,4.52
    C881.53,785.79,880.88,786.78,880.43,787.61z M917.21,821.32l-4.54-2.82l-2.07,3.86l-1-7.46c0,0-2.24,4.49-2.66,6.44
    c-0.43,1.96-3.06-11.71-3.06-11.71c1.1-0.27,1.98-0.7,2.66-1.21l11.78,1.07l-4,3.33l5.22,2.35l-4.87,0.66L917.21,821.32z
     M934.77,798.43c-1.16,0.35-4.32,0.62-7.45,0.82c-0.56-0.35-1.16-0.57-1.75-0.71c0.24-1.35,0.33-2.96,0.08-4.66
    c2.4-2.53,6.46-6.37,8.71-6.13l-1.4,3.34c0,0,6.82-1.11,9.57-0.7c0,0-8.22,5.5-8.85,5.21
    C933.68,795.6,937.32,797.66,934.77,798.43z"
            />
            <path
              class="green"
              d="M950.6,780.68c-0.93-0.29-1.93-0.55-3.02-0.76l-0.01,0c-1.61-0.3-3.4-0.48-5.42-0.55"
            />
            <path
              class="green"
              d="M919.06,771.37c0.48-2.75,2.03-5.98,4.52-8.47"
            />
            <path
              class="green"
              d="M898.99,766.27c-0.26,0.31-0.52,0.64-0.77,0.99"
            />
            <path class="green" d="M877.39,769c3.35,2.01,5.69,4.18,5.69,4.18" />
            <path
              class="green"
              d="M856.47,776.13c2.83,0.07,4.92,0.52,4.92,0.52"
            />
            <path
              class="green"
              d="M850.45,805.31c-0.1-0.14-0.2-0.3-0.29-0.45"
            />
            <path class="green" d="M848.72,797.55c0.18-1.8,0.6-3.05,0.6-3.05" />
            <path class="green" d="M870.1,807.2c0,0-0.86,0.86-1.9,2.35" />
            <path
              class="green"
              d="M889.98,835.36c-1.57-5.2-0.93-10.35-0.93-10.35"
            />
            <path
              class="green"
              d="M915.12,844.36c-1.7-0.4-3.12-0.95-4.32-1.61"
            />
            <path
              class="green"
              d="M910.71,842.7c-9.08-5.11-4.78-16.74-4.78-16.74"
            />
            <path class="green" d="M920.83,846.88c0,0,0.17,4.75,3.53,8.02" />
            <path class="green" d="M934.89,838.68c0,0,6.21,1.35,11.41-1.4" />
            <path
              class="green"
              d="M947.53,821.98c0,0,1.55-1.44,2.34-3.71c0.03-0.1,0.06-0.21,0.1-0.31"
            />
            <path class="green" d="M937.14,809.49c0,0,6.58-4.01,10.84,0.63" />
            <path
              class="green"
              d="M881.9,789.1l-0.01-0.01c-0.52-0.44-1.05-0.84-1.61-1.22c-5.03-3.44-11.24-4.3-12.77,1.98
    c-2.04,8.36,5.18,9.72,5.18,9.72"
            />
            <path
              class="green"
              d="M882.39,784.86c2.54-2.79,6.93-5,13.71-0.66"
            />
            <path
              class="green"
              d="M902.35,790.67c0,0,4.31-12.67,15.98-6.4c4.96,2.66,6.82,6.3,7.32,9.61"
            />
            <path
              class="green"
              d="M927.32,799.25c1.47,0.87,2.77,2.54,3.32,5.6c1.53,8.67-4.81,9.55-4.81,9.55"
            />
            <path class="green" d="M921.4,798.69c0,0,2-0.65,4.18-0.15" />
            <path
              class="green"
              d="M884.49,802.14c0,0-1.77,11.01,6.75,12.79c4.86,1.01,7.35-2.26,8.6-5.27"
            />
            <path class="green" d="M908.69,800.08c0,0,1.56,5.55-2.15,8.33" />
            <path
              class="green"
              d="M903.88,809.63c-1.61,0.41-2.95,0.35-4.05,0.02c-3.66-1.09-4.67-5.19-4.67-5.19"
            />
            <path
              class="green"
              d="M859.22,811.19c-0.38,0.31-0.8,0.64-1.22,0.96c-0.02-0.34-0.01-0.64,0-0.87
    C859.77,810.52,860.53,810.12,859.22,811.19z"
            />
            <path
              class="green"
              d="M910.65,842.79l-7.74,10.28l-4.21,5.61l-1.12-2.25l-9.04,6.42l-0.08-3.56l-10.97,3.35l10.99-8.19l-2.24-1.38
    l10.63-4.24l-3.32-1.74c0,0,2.83-0.75,6.36-1.66C903.5,844.51,907.82,843.43,910.65,842.79z"
            />
            <path
              class="green"
              d="M914.67,815.83l2.54,5.49l-4.54-2.82l-2.07,3.86l-1-7.46c0,0-2.24,4.49-2.66,6.44
    c-0.43,1.96-3.06-11.71-3.06-11.71c1.1-0.27,1.98-0.7,2.66-1.21l11.78,1.07l-4,3.33l5.22,2.35L914.67,815.83z"
            />
            <path
              class="green"
              d="M934.77,798.43c-1.16,0.35-4.32,0.62-7.45,0.82c-0.56-0.35-1.16-0.57-1.75-0.71
    c0.24-1.35,0.33-2.96,0.08-4.66c2.4-2.53,6.46-6.37,8.71-6.13l-1.4,3.34c0,0,6.82-1.11,9.57-0.7c0,0-8.22,5.5-8.85,5.21
    C933.68,795.6,937.32,797.66,934.77,798.43z"
            />
            <path
              class="green"
              d="M882.39,784.86c-0.86,0.93-1.51,1.92-1.96,2.75c-3.84-3.47-9.03-5.55-9.03-5.55s2.06,0.28,2.27-0.69
    c0.2-0.95-4.49-6.62-4.78-6.98l4.71,2.42l0.47-2.16l4.31,5.69C879.54,779.28,881.28,782.46,882.39,784.86z"
            />
            <path
              class="green"
              d="M884.33,793.51c-0.37-1.6-1.27-3.09-2.44-4.42c-0.45-0.52-0.95-1.01-1.47-1.48"
            />
            <line
              class="green"
              x1="868.89"
              y1="774.39"
              x2="868.87"
              y2="774.38"
            />
            <path
              class="green"
              d="M960.96,776.28l-6.36,3.27c0.48,0.75-0.42,1.45-1.75,2.04c-0.69-0.34-1.44-0.64-2.25-0.91
    c-0.02-0.96-0.07-2.14-0.22-3.46c2.28-2.51,3.74-4.85,3.74-4.85s-0.64,1.98,0.29,2.36c0.92,0.38,7.7-3.52,7.7-3.52l-3.2,4.24
    L960.96,776.28z"
            />
            <line
              class="green"
              x1="947.58"
              y1="779.92"
              x2="947.57"
              y2="779.92"
            />
            <path
              class="green"
              d="M902.56,762.6c-1.19,0.98-2.39,2.2-3.57,3.67c-4.5-0.82-10.81-2.05-10.15-2.38c1.01-0.5,2.76-3.07,0.85-4.06
    c-1.92-0.98-8.33-4.42-4.21-4.55s-6.22-9.54-3.45-7.91c2.77,1.62,10.32,9.26,10.83,6.89c0.52-2.38,0.27-6.07,1.43-1.96
    c1.17,4.13,3.04,9.65,3.47,7.7C898.13,758.29,900.32,755.41,902.56,762.6z"
            />
            <path
              class="green"
              d="M868.2,809.55c-0.58,0.82-1.22,1.84-1.79,3.02c-1.85,0.61-5.01,1.63-7.63,2.34c-1.19,0.33-2.28,0.6-3.07,0.73
    c-2.99,0.52-0.28-1.48,2.29-3.49c0.42-0.32,0.84-0.65,1.22-0.96c1.31-1.07,0.55-0.67-1.22,0.09c-1.98,0.87-5.23,2.2-8.27,2.47
    c-5.75,0.52-3.25-1.45-0.9-2.94c2.33-1.47-5.07-0.13-9.32-0.34c-4.26-0.22,0.77-2.59,2.35-3.27c1.58-0.68-8.64,0.17-11.89-2.37
    c-3.26-2.54,13.66,1.73,11.84-2.47c-1.62-3.75,8.27,3.28,8.64,2.95c0.05-0.03-0.03-0.17-0.29-0.45c0,0-0.01,0-0.02-0.01
    c-0.75-0.81-0.97-1.49-0.91-1.99v-0.01c0.12-1.17,1.68-1.52,1.52-0.77c-0.24,1.08,6.43,3.33,5.98,1.3
    C856.4,801.88,864.1,806.83,868.2,809.55z"
            />
            <path
              class="green"
              d="M987.68,815.97c0,0-13.19,5.62-37.39-0.77c-0.04-0.6-0.16-1.23-0.39-1.88c0.52-0.11,1.12-0.23,1.76-0.38
    c7.07,2.14,20.23,4.51,34.05-1.33L987.68,815.97z"
            />
            <path
              class="green"
              d="M970.19,794.89c-2.84,2.75-5.04,1.63-3.62,0.72s0.43-4.83-3.13-0.68c-1.18,1.36-2.43,2.85-3.51,4.16
    c-1.29,1.56-2.36,2.88-2.86,3.47c1.4-1.74,2.85-6.65,0.55-4.02c-1.95,2.24-7.9,8.38-9.63,11.58c0.25,0.26,0.49,0.55,0.72,0.88
    c0.28,0.41,0.52,0.8,0.72,1.2c0.19,0.38,0.35,0.75,0.47,1.12c0.52-0.11,1.12-0.23,1.76-0.38c2.69-0.62,6.18-1.49,7.44-1.41
    c1.92,0.11,0.16-1.8-1.05-2.06c1.96-0.1,9.74-0.74,11-1.74c1.49-1.22-3.81-1.96-1.54-2.18c2.26-0.22,10.13-3.81,8.41-5.12
    c-1.73-1.31,1.29-5.77,2.69-7.51C980.01,791.18,973.04,792.15,970.19,794.89z M957.61,809.48c0.02-0.02,0.04-0.02,0.08-0.03
    c0.11-0.01,0.22-0.01,0.34,0.01C957.79,809.47,957.64,809.48,957.61,809.48z"
            />
            <path
              class="green"
              d="M956.83,802.86c0.05-0.06,0.13-0.16,0.24-0.3"
            />
            <path
              class="green"
              d="M956.8,802.9c-0.01,0.01-0.01,0.01-0.01,0.01"
            />
            <path
              class="green"
              d="M956.83,802.86c0.05-0.06,0.13-0.16,0.24-0.3"
            />
            <path
              class="green"
              d="M958.05,809.47c-0.01,0-0.02,0-0.03-0.01C958.03,809.47,958.04,809.47,958.05,809.47"
            />
            <path
              class="green"
              d="M982.14,841.47c-1.02,1.11-13.48-6.53-13.12-3.98c0.37,2.55-0.75,3.71-2.21,0.64
    c-1.46-3.06-7.32-8.85-7.11-7.58c0.22,1.29-1.03,8.57-1.6,5.69c-0.37-1.91-2.43-6.84-5.05-10.11c0.18-3.26-0.98-5.77-2.65-7.69
    c6.2,1.94,15.62,5,15.81,5.66c0.29,0.98-2.93,1.85-2.02,2.28c0.91,0.44,15.57,3.63,13.19,5.16c-2.38,1.53-5.83,3.19-3.34,3.55
    C976.53,835.45,983.15,840.35,982.14,841.47z"
            />
          </g>
          <g>
            <path
              class="green"
              d="M1251.39,778.18c-2.26-4.9-5.39-7.04-8.43-7.78c2.64-15.01-8.61-18.6-13.62-19.46l-6.06,13.54
    c0.02,0.06,0.02,0.11,0.05,0.17c-0.03-0.02-0.07-0.04-0.11-0.06l0.06-0.11c-0.92-3.09-2.2-7.87-3.25-11.86
    c-4.73-4.71-10.57-4.81-15.56-3.51c-0.44-4.55-2.95-14.46-16.32-17.1c-5.74-1.13-10.18,0.07-13.55,2.21
    c-2.58,1.63-4.53,3.8-5.96,5.88c-0.86,1.25-1.53,2.47-2.04,3.52c-4.98-2.3-14.18-6.74-12.49-7.32c2.29-0.77-3.64-5.82-4.59-4.95
    c-0.67,0.6-1.18-1.1-0.07-1.91c-2.22,0.52-4.15,1.63-5.59,2.67c-4.23-3.45-12.24-4.84-18.12,2.96c-4.44,5.89-1.76,12.82,0.9,17.22
    c-12.07,12.54-3.13,20.39,4.35,24.28c-6.72,6.97-4.51,13.7-2.44,17.25c2.04,1.25,3.66-1.96,3.6-3.23
    c-0.03-0.83,4.67,4.49,7.97,8.31c-0.83,2.01-1.39,3.87-1.72,5.61c-2.33,12.15,6.52,17.73,11.86,19.95
    c-1.69,5.72-0.67,12.4,6.69,17.27c7.56,5,16.58,2.53,22.41-0.13c1.4-0.64,2.61-1.29,3.59-1.85c0.71,0.62,1.42,1.16,2.14,1.61
    c8.3,5.45,16.41,0.81,21.46-3.64c0.85-2.16,1.58-3.97,1.9-4.81c-0.97,2.38-5.11,6.7-3.73,2.93c1.17-3.2,4.06-12.57,6.32-16.13
    c0.39,0.09,0.83,0.14,1.28,0.17c0.56,0.02,1.09,0.02,1.6-0.03c0.49-0.04,0.94-0.11,1.38-0.21c0.78-0.17,1.47-0.43,2.1-0.75
    c1.05-0.53,1.9-1.22,2.59-1.95c0.24,0.05,0.47,0.1,0.72,0.12v0.01c2.84,0.45,6,0.07,9.17-2.04c0.94-0.63,1.87-1.4,2.79-2.35
    c3.59-3.65,4.73-7.39,4.68-10.76C1247.87,799.78,1256.84,790.01,1251.39,778.18z M1149.64,771.92c-3.02,0.37-7.17,0.59-6.73-1.15
    l-8.08-0.73l1.91-1.74l-5.02-3.08c0.52,0.07,8.78,1.19,9.62,0.43c0.83-0.75-0.42-2.42-0.54-2.58c0.3,0.22,5.1,3.77,10.52,5.33
    C1150.74,769.33,1150.1,770.54,1149.64,771.92z M1188.61,814.66c0.63,0.43-0.36,11.58-0.36,11.58c-1.92-2.4-4.56-9.59-4.56-9.59
    l-2.58,3.33c-1.48-2.01,0.15-8.19,1.36-12c1.85-0.77,3.41-1.81,4.64-2.84c0.45,0.48,1,0.92,1.67,1.25
    c1.51,3.12,2.98,6.3,3.27,7.62C1192.68,816.92,1188.61,814.66,1188.61,814.66z M1198.45,784.4l2.01,5.05l-5.23-3.6l-1.13,5.82
    l-7.55-10.64c0.14-0.97,0.08-2.06-0.25-3.27c0,0,15.16-5.63,13.43-4.06c-1.68,1.52-4.8,6.09-4.99,6.38l8.02-3.47l-2.73,4.28
    l5.32,2.67L1198.45,784.4z"
            />
            <path
              class="green"
              d="M1176.99,832.45c1.17,1.89,2.34,3.49,3.53,4.86l0.01,0.01c0.81,0.92,1.61,1.72,2.42,2.44"
            />
            <path
              class="green"
              d="M1150.26,824.46c1.13-3.86,3.52-7.27,6.01-9.38"
            />
            <path
              class="green"
              d="M1140.69,797.57c-0.21,0.44-0.4,0.89-0.57,1.32"
            />
            <path
              class="green"
              d="M1130.99,776.57c3.85,2.02,7.32,2.97,7.32,2.97"
            />
            <path
              class="green"
              d="M1126.64,752.29c1.62,2.67,3.22,4.4,3.22,4.4"
            />
            <path class="green" d="M1151.98,729.13c0.2-0.01,0.41,0,0.61,0.01" />
            <path class="green" d="M1141.13,734.5c0,0,1.02-1.15,2.73-2.39" />
            <path
              class="green"
              d="M1166.6,743.62c-0.93,1.89-1.31,3.22-1.31,3.22"
            />
            <path class="green" d="M1193.57,754.38c0,0,4.82-3.68,10.9-5.27" />
            <path
              class="green"
              d="M1227.32,767.83c-1.33-1.39-2.67-2.43-3.99-3.18"
            />
            <path class="green" d="M1203.81,769.99c0,0,9.3-11.05,19.41-5.4" />
            <path class="green" d="M1232.98,771.8c0,0,4.86-2.66,9.98-1.4" />
            <path class="green" d="M1232.48,790.16c0,0,4.77,5.14,4.87,11.76" />
            <path
              class="green"
              d="M1219.99,816.94c0.09-0.09,0.17-0.19,0.26-0.28c1.84-2.11,2.43-4.45,2.43-4.45"
            />
            <path
              class="green"
              d="M1211.04,819.71c-7-1.32-6.59-10.01-6.59-10.01"
            />
            <path
              class="green"
              d="M1159.07,753.87c0,0-5.34-6.11-12.6,0.83c-5.46,5.2-1.18,10.64,5.03,13.42c0.68,0.31,1.38,0.58,2.11,0.81
    l0.02,0"
            />
            <path
              class="green"
              d="M1156.51,785.45c-8.08-3.91-8.28-9.43-6.87-13.53"
            />
            <path
              class="green"
              d="M1182.47,807.98c-3.6,1.5-8.27,1.88-13.66-1.28c-12.71-7.45-2.37-19.13-2.37-19.13"
            />
            <path
              class="green"
              d="M1203.15,795.94c0,0,2.61,6.59-6.93,10.29c-3.37,1.31-5.76,1.05-7.44,0.16"
            />
            <path
              class="green"
              d="M1187.11,805.14c-1.7-1.78-2.15-4.09-2.15-4.09"
            />
            <path
              class="green"
              d="M1184.1,773.87c2.34-2.99,4.25-7.33,0.56-11.38c-6.47-7.1-16.53,1.15-16.53,1.15"
            />
            <path
              class="green"
              d="M1186.55,781.03c-0.76,5.21-7.18,7.02-7.18,7.02"
            />
            <path
              class="green"
              d="M1176.32,772.48c0,0,4.67-1.47,7.78,1.39c0.93,0.85,1.72,2.1,2.2,3.89"
            />
            <path
              class="green"
              d="M1174.6,734.22c-2.58,1.63-4.53,3.8-5.96,5.88c-0.4-2.13-1.11-5.76-1.84-8.69
    C1168.87,731.25,1171.54,731.81,1174.6,734.22z"
            />
            <path
              class="green"
              d="M1176.05,735.48c-0.5-0.47-0.98-0.88-1.45-1.26"
            />
            <path
              class="green"
              d="M1163.61,732.3c-0.09,0.59-0.19,1.19-0.3,1.74c-0.35,1.89-0.37,0.93-0.58-1.23
    C1162.96,732.67,1163.25,732.49,1163.61,732.3z"
            />
            <path
              class="green"
              d="M1232.65,743.57l-3.31,7.37l-6.06,13.54c-0.92-3.09-2.2-7.87-3.25-11.86c-1.03-3.93-1.84-7.08-1.84-7.08
    l3.58,2.14l-1.6-12.71l2.62,1.33l2.18-15.41l2.65,12.51l3.63-2.05l-1.47,12.49L1232.65,743.57z"
            />
            <path
              class="green"
              d="M1198.45,784.4l2.01,5.05l-5.23-3.6l-1.13,5.82l-7.55-10.64c0.14-0.97,0.08-2.06-0.25-3.27
    c0,0,15.16-5.63,13.43-4.06c-1.68,1.52-4.8,6.09-4.99,6.38l8.02-3.47l-2.73,4.28l5.32,2.67L1198.45,784.4z"
            />
            <path
              class="green"
              d="M1188.61,814.66c0.63,0.43-0.36,11.58-0.36,11.58c-1.92-2.4-4.56-9.59-4.56-9.59l-2.58,3.33
    c-1.48-2.01,0.15-8.19,1.36-12c1.85-0.77,3.41-1.81,4.64-2.84c0.45,0.48,1,0.92,1.67,1.25c1.51,3.12,2.98,6.3,3.27,7.62
    C1192.68,816.92,1188.61,814.66,1188.61,814.66z"
            />
            <path
              class="green"
              d="M1151.32,768.4c-0.58,0.93-1.22,2.14-1.68,3.52c-3.02,0.37-7.17,0.59-6.73-1.15l-8.08-0.73l1.91-1.74
    l-5.02-3.08c0.52,0.07,8.78,1.19,9.62,0.43c0.83-0.75-0.42-2.42-0.54-2.58C1141.1,763.29,1145.9,766.84,1151.32,768.4z"
            />
            <path
              class="green"
              d="M1151.32,768.4c0.75,0.23,1.52,0.41,2.29,0.53c1.97,0.32,3.96,0.31,5.77-0.3"
            />
            <line
              class="green"
              x1="1131.7"
              y1="765.21"
              x2="1131.72"
              y2="765.22"
            />
            <path
              class="green"
              d="M1184.02,844.25l0.21,8.05l-1.96-1.47l-2.49,5.59c0,0,0.18-8.82-0.7-9.48c-0.83-0.61-2.29,0.89-2.51,1.11
    c0.17-0.32,1.61-3,2.79-6.45c1.4-0.64,2.61-1.29,3.59-1.85c0.71,0.62,1.42,1.16,2.14,1.61
    C1185.24,843,1185.03,844.27,1184.02,844.25z"
            />
            <line
              class="green"
              x1="1180.52"
              y1="837.3"
              x2="1180.53"
              y2="837.31"
            />
            <path
              class="green"
              d="M1140.12,798.9c-0.83,2.01-1.39,3.87-1.72,5.61c-8.44,2.12-6.76-1.68-5.25-3.06
    c1.73-1.57-4.84-0.07-9.62,1.26c-4.76,1.34-0.93-0.62,1.17-2.52c2.1-1.91-9.71-4.6-12.86-6.28c-3.15-1.68,11.97,2.61,9.83-1.41
    c-2.14-4.02,4.84,0.07,6.88,1.32s3.66-1.96,3.6-3.23C1132.12,789.76,1136.82,795.08,1140.12,798.9z"
            />
            <path
              class="green"
              d="M1168.64,740.1c-0.86,1.25-1.53,2.47-2.04,3.52c-4.98-2.3-14.18-6.74-12.49-7.32
    c2.29-0.77-3.64-5.82-4.59-4.95c-0.67,0.6-1.18-1.1-0.07-1.91l0.01-0.01c0.48-0.36,1.27-0.55,2.5-0.3c0.02,0,0.02,0,0.02,0
    c0.43,0.08,0.61,0.08,0.62,0.01c0.12-0.55-12.37-5.83-7.71-6.52c5.21-0.76-8.37-14.42-4.04-12.81c4.34,1.6,9.1,11.89,8.91,9.97
    c-0.18-1.92-0.57-8.14,1.99-4.19c2.55,3.94,5.27,11.84,5.47,8.72c0.2-3.14,0.81-6.7,3.45-0.88c1.39,3.07,1.84,6.97,2.06,9.38
    c0.21,2.16,0.23,3.12,0.58,1.23c0.11-0.55,0.21-1.15,0.3-1.74c0.6-3.66,1.12-7.45,2.24-4.28c0.3,0.85,0.63,2.04,0.95,3.39
    C1167.53,734.34,1168.24,737.97,1168.64,740.1z"
            />
            <path
              class="green"
              d="M1238.73,854.25l-5.45,0.71c-1.74-16.71-11.36-27.91-17.39-33.41c-0.21-0.7-0.41-1.35-0.59-1.91
    c0.78-0.17,1.47-0.43,2.1-0.75C1237.11,838.27,1238.73,854.25,1238.73,854.25z"
            />
            <path
              class="green"
              d="M1215.92,829.74c0.93,1,3.81,1.55,2.64-0.22c-0.77-1.16-1.81-5.02-2.67-7.97c-0.21-0.7-0.41-1.35-0.59-1.91
    c-0.44,0.1-0.89,0.17-1.38,0.21c-0.51,0.05-1.04,0.05-1.6,0.03c-0.45-0.03-0.89-0.08-1.28-0.17c-2.26,3.56-5.15,12.93-6.32,16.13
    c-1.38,3.77,2.76-0.55,3.73-2.93c-0.32,0.84-1.05,2.65-1.9,4.81c-0.72,1.82-1.53,3.9-2.25,5.84c-2.2,5.88,2.27,4.5,2.41,2.6
    c0.12-1.91,2.45-0.46,1.25,3.9c-1.18,4.35,1.68,11.61,2.66,9.23s3.79-7.92,6.06-7.04c2.25,0.87,1.53-8.81,0.51-11.11
    c-1.02-2.31,2.63,2.32,3.02,0.17C1220.54,839.51,1216.9,831.67,1215.92,829.74z M1215.7,829.41c-0.01-0.05-0.02-0.07-0.01-0.09
    c0.02,0.02,0.09,0.17,0.21,0.4C1215.81,829.62,1215.74,829.52,1215.7,829.41z"
            />
            <path
              class="green"
              d="M1208.45,832.91c0.08-0.19,0.14-0.32,0.17-0.4"
            />
            <path class="green" d="M1208.65,832.44c0,0,0,0,0,0.02" />
            <path
              class="green"
              d="M1208.45,832.91c0.08-0.19,0.14-0.32,0.17-0.4"
            />
            <path
              class="green"
              d="M1215.92,829.74c-0.01-0.01-0.02-0.02-0.02-0.02C1215.91,829.73,1215.92,829.74,1215.92,829.74"
            />
            <path
              class="green"
              d="M1261.25,833.76c-0.56,1.63-9.12-1.79-10.84-3.97c-1.73-2.17-1.5,2.13-1.73,5.32s-11.48-8.95-12.42-9.56
    s-0.04,2.99-1.18,3.3c-0.77,0.2-9.01-7-14.37-11.78c2.84,0.45,6,0.07,9.17-2.04c4.72,0.56,10.8-0.41,12.92-1.19
    c3.2-1.17-3.42,4.36-4.83,4.93c-1.39,0.55,7.64,2.72,11.51,2.28c3.89-0.43,3.33,1.35,0.58,2.51
    C1247.3,824.73,1261.82,832.11,1261.25,833.76z"
            />
          </g>
          <g>
            <path
              class="green"
              d="M1018.49,752.31c0.58,1.14,0.86,4.09-0.11,2.35c-0.82-1.48-3.4-5.61-4-7.62c0.16-0.12,0.32-0.26,0.47-0.43
    c0.2-0.2,0.37-0.4,0.52-0.6c0.14-0.2,0.26-0.4,0.37-0.59c0.18-0.35,0.31-0.7,0.4-1.04c0.14-0.56,0.16-1.1,0.11-1.6
    c0.09-0.07,0.19-0.15,0.28-0.23c1.09-0.92,1.98-2.23,2.22-4.11c0.06-0.56,0.08-1.16,0.02-1.81c-0.2-2.53-1.24-4.18-2.52-5.26
    c2.62-4.65,1.87-11.19-4.35-12.99c-2.57-0.75-4.39-0.27-5.66,0.63c-4.78-5.87-9.79-2.81-11.74-1.21l3.12,6.68
    c0.02,0.01,0.05,0.03,0.07,0.04c-0.02,0-0.03,0.01-0.05,0.02l-0.02-0.06c-1.46-0.66-3.68-1.73-5.52-2.63
    c-3.3,0.24-5.24,2.4-6.37,4.7c-1.86-1.32-6.4-3.6-11.73,0.56c-2.3,1.79-3.29,3.85-3.58,5.81c-0.23,1.5-0.05,2.94,0.27,4.15
    c0.19,0.73,0.43,1.38,0.66,1.91c-2.49,1.12-7.14,3.14-6.81,2.31c0.45-1.11-3.37-0.52-3.36,0.12c0.01,0.44-0.79,0.08-0.74-0.6
    c-0.52,1-0.74,2.09-0.81,2.97c-2.67,0.47-5.8,3.02-4.78,7.77c0.77,3.58,4.24,4.83,6.75,5.26c0.79,8.61,6.65,7.8,10.54,6.26
    c0.43,4.79,3.68,6.15,5.68,6.53c1.14-0.36,0.46-2.02-0.04-2.41c-0.32-0.25,3.21-0.29,5.72-0.29c0.48,0.97,1,1.79,1.54,2.48
    c3.81,4.82,8.78,3.31,11.35,2.03c1.6,2.5,4.44,4.29,8.66,3.11c4.34-1.22,6.35-5.41,7.24-8.46c0.22-0.74,0.37-1.4,0.48-1.95
    c0.46-0.07,0.9-0.16,1.3-0.28c4.74-1.35,5.64-5.9,5.61-9.24C1019.14,753.56,1018.7,752.7,1018.49,752.31z M973.84,756.71
    l-2.91,2.8l-0.03-1.29l-2.78,0.89c0.19-0.18,3.3-2.92,3.28-3.48c-0.01-0.58-1.15-0.63-1.15-0.63s3.01-0.64,5.43-2.22
    c0.16,0.52,0.41,1.16,0.78,1.78C975.62,755.81,974.35,757.44,973.84,756.71z M998.34,744.28l-6.46-0.62
    c-0.31-0.37-0.74-0.7-1.31-0.97c0,0,2.82-7.53,2.85-6.37c0.03,1.16,0.77,3.96,0.77,3.96l1.31-4.15l0.72,2.42l2.73-1.13l-1.93,2.86
    l2.55,0.89l-3.05,0.79L998.34,744.28z M1004.33,756.32l0.41,2.05c-1.23-0.1-3.03-2.72-4.06-4.41c0.31-0.95,0.43-1.88,0.44-2.67
    c0.33-0.02,0.67-0.08,1.01-0.22c1.67,0.44,3.34,0.93,3.93,1.25c1.23,0.68-0.67,1.42-0.86,1.5c0.44,0,4.22,3.9,4.22,3.9
    C1007.89,757.66,1004.33,756.32,1004.33,756.32z"
            />
            <path
              class="green"
              d="M1008.08,763.97c1.09,0.17,2.07,0.26,2.97,0.25l0.01,0c0.61,0,1.17-0.05,1.7-0.12"
            />
            <path
              class="green"
              d="M994.82,766.1c-0.02,1.62,0.49,3.63,1.57,5.31"
            />
            <path
              class="green"
              d="M983.18,766.26c0.1,0.22,0.2,0.44,0.31,0.65"
            />
            <path
              class="green"
              d="M972.14,763.07c2.01-0.79,3.49-1.78,3.49-1.78"
            />
            <path
              class="green"
              d="M961.6,756.81c1.53,0.26,2.71,0.22,2.71,0.22"
            />
            <path
              class="green"
              d="M961.36,739.54c-0.08,0.07-0.14,0.14-0.21,0.22"
            />
            <path class="green" d="M959.64,745.58c0,0-0.1-0.76-0.01-1.8" />
            <path
              class="green"
              d="M971.35,738.98c0.41,0.96,0.78,1.54,0.78,1.54"
            />
            <path class="green" d="M984.16,732.35c0,0,0.19-3,1.57-5.8" />
            <path
              class="green"
              d="M1000.19,724.05c-0.96,0.05-1.79,0.21-2.5,0.47"
            />
            <path class="green" d="M993.35,733.58c0,0-1.12-7.08,4.29-9.04" />
            <path class="green" d="M1003.52,723.22c0,0,0.58-2.69,2.72-4.21" />
            <path class="green" d="M1010.25,729.38c0,0,3.48-0.12,6,1.99" />
            <path
              class="green"
              d="M1015.35,740.23c0,0,0.68,0.98,0.88,2.36c0,0.06,0.01,0.13,0.02,0.19"
            />
            <path
              class="green"
              d="M1014.38,747.04c-2.77,2.2-5.9-0.78-5.9-0.78"
            />
            <path
              class="green"
              d="M972.75,745.14c0,0-4.03,0.02-3.79,5c0.18,3.74,3.61,3.91,6.68,2.47c0.34-0.16,0.67-0.33,0.99-0.53l0.01-0.01
    "
            />
            <path
              class="green"
              d="M983.77,756.38c-4.1,1.76-6.24,0.04-7.32-1.82"
            />
            <path
              class="green"
              d="M1000.68,753.96c-0.61,1.84-1.98,3.72-4.93,4.71c-6.93,2.35-7.95-5.33-7.95-5.33"
            />
            <path
              class="green"
              d="M1002.88,742.27c0,0,3.33,1.16,1.61,5.95c-0.61,1.69-1.48,2.5-2.36,2.85"
            />
            <path
              class="green"
              d="M1001.12,751.29c-1.22,0.06-2.23-0.52-2.23-0.52"
            />
            <path
              class="green"
              d="M988.4,742.25c-0.36-1.85-1.37-3.98-4.09-3.91c-4.77,0.12-4.95,6.58-4.95,6.58"
            />
            <path
              class="green"
              d="M991.88,743.66c1.71,1.98,0.3,4.98,0.3,4.98"
            />
            <path
              class="green"
              d="M985.35,744.72c0,0,0.97-2.23,3.05-2.47c0.62-0.07,1.35,0.04,2.18,0.44"
            />
            <path
              class="green"
              d="M966.83,734.93c0.61-0.83,1.69-1.65,3.59-2.01c0.29-0.06,0.61-0.1,0.95-0.14"
            />
            <path
              class="green"
              d="M966.03,736.92c0.02-0.13,0.05-0.3,0.09-0.5c0.19,0.23,0.39,0.46,0.56,0.68
    C967.28,737.85,966.91,737.54,966.03,736.92z"
            />
            <path
              class="green"
              d="M997.62,724.48c-1.46-0.66-3.68-1.73-5.52-2.63c-1.81-0.9-3.25-1.62-3.25-1.62l1.96-0.64l-5.29-3.54
    l1.36-0.55l-5.08-5.83l5.56,3.07l0.41-2.03l4.21,4.62l0.83-1.17l1.69,3.64L997.62,724.48z"
            />
            <path
              class="green"
              d="M996.52,741.96l1.82,2.32l-6.46-0.62c-0.31-0.37-0.74-0.7-1.31-0.97c0,0,2.82-7.53,2.85-6.37
    c0.03,1.16,0.77,3.96,0.77,3.96l1.31-4.15l0.72,2.42l2.73-1.13l-1.93,2.86l2.55,0.89L996.52,741.96z"
            />
            <path
              class="green"
              d="M1004.33,756.32l0.41,2.05c-1.23-0.1-3.03-2.72-4.06-4.41c0.31-0.95,0.43-1.88,0.44-2.67
    c0.33-0.02,0.67-0.08,1.01-0.22c1.67,0.44,3.34,0.93,3.93,1.25c1.23,0.68-0.67,1.42-0.86,1.5c0.44,0,4.22,3.9,4.22,3.9
    C1007.89,757.66,1004.33,756.32,1004.33,756.32z"
            />
            <path
              class="green"
              d="M976.46,754.56c-0.84,1.25-2.11,2.88-2.62,2.15l-2.91,2.8l-0.03-1.29l-2.78,0.89
    c0.19-0.18,3.3-2.92,3.28-3.48c-0.01-0.58-1.15-0.63-1.15-0.63s3.01-0.64,5.43-2.22C975.84,753.3,976.09,753.94,976.46,754.56z"
            />
            <path
              class="green"
              d="M975.68,752.78c0.33-0.21,0.65-0.44,0.94-0.69c0.76-0.63,1.4-1.39,1.77-2.26"
            />
            <line
              class="green"
              x1="968.11"
              y1="759.11"
              x2="968.12"
              y2="759.11"
            />
            <path
              class="green"
              d="M1018,770.72c0,0-3.26-2.94-3.79-2.82c-0.54,0.12-0.4,1.32-0.4,1.32s-0.54-1.49-1.52-3.16
    c0.22-0.74,0.37-1.4,0.48-1.95c0.46-0.07,0.9-0.16,1.3-0.28c0.66,0.47,1.07,0.96,0.73,1.34l3.09,2.54l-1.18,0.26L1018,770.72z"
            />
            <line
              class="green"
              x1="1011.06"
              y1="764.22"
              x2="1011.06"
              y2="764.22"
            />
            <path
              class="green"
              d="M985.04,769.38c-1.94,3.86-2.83,1.99-2.85,0.97c-0.03-1.16-1.6,1.8-2.66,4.03c-1.05,2.22-0.53,0.14-0.57-1.27
    c-0.03-1.41-4.88,2.16-6.54,2.79c-1.66,0.64,4.88-3.64,2.67-4.15c-2.21-0.5,1.6-1.79,2.73-2.15c1.14-0.36,0.46-2.02-0.04-2.41
    c-0.32-0.25,3.21-0.29,5.72-0.29C983.98,767.87,984.5,768.69,985.04,769.38z"
            />
            <path
              class="green"
              d="M971.35,738.98c-2.49,1.12-7.14,3.14-6.81,2.31c0.45-1.11-3.37-0.52-3.36,0.12c0.01,0.44-0.79,0.08-0.74-0.6
    v-0.01c0.02-0.29,0.21-0.65,0.7-1.03c0.01-0.01,0.01-0.01,0.01-0.01c0.15-0.11,0.21-0.19,0.21-0.22v-0.01
    c-0.17-0.22-6.22,2.75-4.96,0.78c1.41-2.21-8.14-1.55-6.13-2.66c2.02-1.1,7.43,0.46,6.65-0.1c-0.78-0.55-3.25-2.43-0.93-2.11
    c2.31,0.32,6.16,1.87,5.05,0.78c-1.11-1.09-2.25-2.48,0.79-1.58c1.61,0.48,3.22,1.58,4.2,2.28c0.88,0.62,1.25,0.93,0.65,0.18
    c-0.17-0.22-0.37-0.45-0.56-0.68c-1.18-1.41-2.43-2.84-0.87-2.23c0.41,0.16,0.97,0.43,1.58,0.74c1.34,0.68,2.93,1.6,3.86,2.14
    C970.88,737.8,971.12,738.45,971.35,738.98z"
            />
            <path
              class="green"
              d="M1016.14,744.38c13.69-1.1,20.22,3.49,20.22,3.49l-1.51,2.28c-6.84-4.78-14.18-4.81-18.2-4.34"
            />
            <path
              class="green"
              d="M1029.11,760.07c-0.58-1.14-1.75-4-0.68-4.56c1.06-0.57-2.81-3.44-4.01-3.81c-1.19-0.37,1.73-0.23,1.05-1.08
    c-0.57-0.71-4.69-1.89-5.74-2.15c0.68-0.02,1.82-0.93,0.78-1.06c-0.69-0.09-2.48-0.95-3.86-1.59c-0.34-0.15-0.65-0.29-0.91-0.4
    c-0.11,0.19-0.23,0.39-0.37,0.59c-0.15,0.2-0.32,0.4-0.52,0.6c-0.15,0.17-0.31,0.31-0.47,0.43c0.6,2.01,3.18,6.14,4,7.62
    c0.97,1.74,0.69-1.21,0.11-2.35c0.21,0.39,0.65,1.25,1.19,2.28c0.45,0.86,0.97,1.84,1.46,2.74c1.49,2.74,2.43,0.61,1.76-0.06
    c-0.68-0.67,0.63-1.07,1.87,0.8C1026.02,759.93,1029.68,761.21,1029.11,760.07z M1019.53,748.44c-0.02-0.01-0.03-0.01-0.03-0.02
    c0.01,0,0.09,0.02,0.22,0.05C1019.65,748.47,1019.59,748.46,1019.53,748.44z"
            />
            <path
              class="green"
              d="M1018.49,752.31c-0.05-0.09-0.08-0.15-0.1-0.19"
            />
            <path
              class="green"
              d="M1018.38,752.08C1018.38,752.08,1018.38,752.08,1018.38,752.08"
            />
            <path
              class="green"
              d="M1018.49,752.31c-0.05-0.09-0.08-0.15-0.1-0.19"
            />
            <path
              class="green"
              d="M1019.73,748.47c-0.01,0-0.01,0-0.02,0C1019.72,748.47,1019.73,748.47,1019.73,748.47"
            />
            <path
              class="green"
              d="M1032.4,737.91c1.13,1.13-7.09,1.4-7.63,1.56c-0.53,0.15,1.11,0.98,0.86,1.51c-0.18,0.36-5.56,1.11-9.1,1.57
    c1.09-0.92,1.98-2.23,2.22-4.11c1.74-1.59,3.35-4.18,3.75-5.24c0.6-1.58,0.53,2.71,0.28,3.42c-0.24,0.7,3.51-1.98,4.6-3.58
    c1.11-1.6,1.59-0.81,1.13,0.6c-0.46,1.41,7.04-1.63,7.47-0.89c0.43,0.75-3.64,2.84-5.01,2.79
    C1029.59,735.48,1031.28,736.79,1032.4,737.91z"
            />
            <line
              class="green"
              x1="1016.53"
              y1="742.55"
              x2="1016.53"
              y2="742.55"
            />
          </g>
          <g>
            <path
              class="green"
              d="M1111.69,811.14c2.96-13.56-6.39-15.16-13.1-14.69c1.66-7.54-2.65-11.19-5.54-12.74
    c-1.91,0.01-1.67,2.87-1.1,3.7c0.36,0.55-5.05-1.1-8.89-2.31c-0.27-1.72-0.67-3.22-1.17-4.54c-3.49-9.23-11.84-9.33-16.39-8.61
    c-1.24-4.59-4.72-8.7-11.75-8.94c-7.24-0.24-12.33,5.21-15.18,9.45c-0.69,1.02-1.24,1.97-1.67,2.75c-0.74-0.12-1.45-0.19-2.13-0.2
    c-7.91-0.23-11.48,6.31-13.06,11.44c0.33,1.83,0.59,3.36,0.71,4.06c-0.33-2.02,0.68-6.68,1.32-3.55
    c0.54,2.67,2.49,10.24,2.44,13.6c-0.31,0.11-0.62,0.25-0.94,0.42c-0.39,0.22-0.75,0.44-1.08,0.69c-0.31,0.23-0.59,0.47-0.85,0.72
    c-0.45,0.44-0.82,0.91-1.11,1.39c-0.49,0.8-0.78,1.62-0.95,2.4c-0.18,0.07-0.35,0.13-0.53,0.22h-0.01
    c-2.12,0.87-4.11,2.46-5.38,5.21c-0.37,0.82-0.68,1.73-0.92,2.76c-0.91,3.98-0.12,7,1.32,9.27c-6.26,5.85-8.27,16.23,0.37,22
    c3.58,2.38,6.6,2.53,8.98,1.76c4.47,11.31,13.62,9.05,17.38,7.54l-1.54-11.73c1.92,1.71,4.79,4.43,7.17,6.7
    c5.18,1.22,9.19-1.15,12.03-4.11c2.21,2.91,8.05,8.6,18.24,4.8c4.37-1.63,6.88-4.3,8.28-7.16c1.07-2.18,1.5-4.47,1.59-6.48
    c0.07-1.21,0.01-2.32-0.08-3.24c4.35-0.52,12.45-1.35,11.55-0.25c-1.24,1.48,4.9,2.44,5.19,1.45c0.19-0.69,1.25,0.26,0.84,1.27
    c1.29-1.28,2.14-2.84,2.68-4.15c4.32,0.58,10.34-1.82,11.08-9.58C1120.04,816.61,1115.34,813.02,1111.69,811.14z M1043.53,794.63
    c-0.61-0.03-4.59-8.02-4.59-8.02c2.31,0.83,7.1,4.61,7.1,4.61l0.37-3.34c1.84,0.75,3.32,5.63,4.08,8.72
    c-0.93,1.3-1.56,2.66-1.96,3.87c-0.51-0.13-1.07-0.2-1.66-0.15c-2.33-1.48-4.66-3.03-5.41-3.81
    C1039.83,794.79,1043.53,794.63,1043.53,794.63z M1053.08,827.11c0.51-1.79,0.73-6.43,0.73-6.43l-4.01,5.71l0.07-4.04l-4.73,0.4
    l4.34-3.44l-3.48-2.6l5.06,0.26l-1.66-4.42l9.58,4.07c0.3,0.72,0.8,1.44,1.53,2.12C1060.51,818.74,1052.56,828.9,1053.08,827.11z
     M1096.12,808.2c-0.26,0.9,1.45,1.53,1.45,1.53s-4.91-0.47-9.38,0.77c0-0.88-0.07-1.97-0.33-3.1c1.9-1.51,4.62-3.39,5.05-2.03
    l5.8-2.87l-0.57,1.97h4.69C1102.45,804.65,1096.37,807.33,1096.12,808.2z"
            />
            <path
              class="green"
              d="M1044,777.69c-1.59-0.79-3.05-1.39-4.43-1.83l-0.01,0c-0.93-0.29-1.82-0.5-2.66-0.65"
            />
            <path
              class="green"
              d="M1065.5,771.95c0.85,3.1,0.65,6.42-0.17,8.89"
            />
            <path
              class="green"
              d="M1083.23,786.23c-0.04-0.39-0.1-0.77-0.17-1.14"
            />
            <path class="green" d="M1092.38,797.49c0,0,2.75-0.8,6.21-1.04" />
            <path class="green" d="M1107.66,809.49c0,0,1.81,0.51,4.03,1.65" />
            <path
              class="green"
              d="M1104.13,837.46c-0.14,0.09-0.28,0.17-0.42,0.25"
            />
            <path
              class="green"
              d="M1108.41,832.04c0.64-1.55,0.86-2.77,0.86-2.77"
            />
            <path
              class="green"
              d="M1088.15,833.72c-0.16-1.67-0.45-2.74-0.45-2.74"
            />
            <path
              class="green"
              d="M1060.12,845.8c3.47-3.62,5.21-8.14,5.21-8.14"
            />
            <path
              class="green"
              d="M1051.85,831.34c0,0-2.19,14.64-15.07,11.28"
            />
            <path class="green" d="M1025.08,847.4c4-1.27,6.2-5.12,6.2-5.12" />
            <path
              class="green"
              d="M1015.73,823.64c2.83,4.46,8.22,5.96,8.22,5.96"
            />
            <path
              class="green"
              d="M1021.4,810.52c0,0-0.58-1.84-0.21-4.04c0.02-0.1,0.04-0.2,0.06-0.3"
            />
            <path
              class="green"
              d="M1026.18,800.56c5.31-2.03,8.66,4.05,8.66,4.05"
            />
            <path
              class="green"
              d="M1088.99,823.61c0,0,6.18,1.92,8.22-5.82c1.54-5.82-3.64-7.73-9.02-7.02c-0.59,0.08-1.18,0.18-1.77,0.33
    l-0.01,0.01"
            />
            <path
              class="green"
              d="M1077.54,801.08c7.13-0.72,9.57,2.95,10.32,6.33"
            />
            <path
              class="green"
              d="M1050.49,796.6c1.82-2.52,4.83-4.73,9.82-4.83c11.75-0.25,9.59,12.01,9.59,12.01"
            />
            <path
              class="green"
              d="M1041.47,813.42c0,0-4.53-3.39,0.41-9.89c1.75-2.3,3.48-3.12,4.99-3.22"
            />
            <path
              class="green"
              d="M1048.53,800.47c1.9,0.5,3.17,1.88,3.17,1.88"
            />
            <path
              class="green"
              d="M1063.63,820.47c-0.34,3.01,0.17,6.76,4.37,7.97c7.36,2.12,10.76-7.69,10.76-7.69"
            />
            <path
              class="green"
              d="M1058.98,816.62c-1.66-3.86,1.95-7.77,1.95-7.77"
            />
            <path
              class="green"
              d="M1069.49,818.16c0,0-2.56,2.95-5.86,2.31c-0.99-0.19-2.05-0.71-3.12-1.72"
            />
            <path
              class="green"
              d="M1095.11,842.1c-1.33,0.97-3.39,1.7-6.47,1.34c-0.48-0.06-0.98-0.14-1.51-0.25"
            />
            <path
              class="green"
              d="M1095.29,839.44c-0.09,0.2-0.22,0.45-0.38,0.72c-0.18-0.44-0.37-0.89-0.53-1.31
    C1093.83,837.42,1094.25,838.07,1095.29,839.44z"
            />
            <path
              class="green"
              d="M1040.92,843.11v0.1c-0.03-0.03-0.06-0.07-0.1-0.1"
            />
            <path
              class="green"
              d="M1057.98,873.53l-7.03-7.39l-1.61,2.91l-4.21-9.1l-1.84,1.38l-0.83-6.39l-1.54-11.73
    c1.92,1.71,4.79,4.43,7.17,6.7c2.34,2.24,4.2,4.04,4.2,4.04l-3.32,0.04l6.39,7.97l-2.34,0.19L1057.98,873.53z"
            />
            <path
              class="green"
              d="M1060.51,818.74c0,0-7.95,10.16-7.43,8.37c0.51-1.79,0.73-6.43,0.73-6.43l-4.01,5.71l0.07-4.04l-4.73,0.4
    l4.34-3.44l-3.48-2.6l5.06,0.26l-1.66-4.42l9.58,4.07C1059.28,817.34,1059.78,818.06,1060.51,818.74z"
            />
            <path
              class="green"
              d="M1050.49,796.6c-0.93,1.3-1.56,2.66-1.96,3.87c-0.51-0.13-1.07-0.2-1.66-0.15c-2.33-1.48-4.66-3.03-5.41-3.81
    c-1.63-1.72,2.07-1.88,2.07-1.88c-0.61-0.03-4.59-8.02-4.59-8.02c2.31,0.83,7.1,4.61,7.1,4.61l0.37-3.34
    C1048.25,788.63,1049.73,793.51,1050.49,796.6z"
            />
            <path
              class="green"
              d="M1097.57,809.73c0,0-4.91-0.47-9.38,0.77c0-0.88-0.07-1.97-0.33-3.1c1.9-1.51,4.62-3.39,5.05-2.03l5.8-2.87
    l-0.57,1.97h4.69c-0.38,0.18-6.46,2.86-6.71,3.73C1095.86,809.1,1097.57,809.73,1097.57,809.73z"
            />
            <path
              class="green"
              d="M1088.19,810.5c-0.61,0.16-1.2,0.36-1.78,0.6c-1.48,0.6-2.82,1.45-3.8,2.61"
            />
            <line
              class="green"
              x1="1102.85"
              y1="804.47"
              x2="1102.83"
              y2="804.47"
            />
            <path
              class="green"
              d="M1038.57,772.46c-0.69,1.02-1.24,1.97-1.67,2.75c-0.74-0.12-1.45-0.19-2.13-0.2c-0.78-1.04-1.17-2-0.48-2.41
    l-3.5-5.38l1.95,0.18l-0.65-4.84c0,0,3.56,6.07,4.44,6.15c0.88,0.07,1.24-1.83,1.24-1.83S1037.89,769.43,1038.57,772.46z"
            />
            <line
              class="green"
              x1="1039.57"
              y1="775.86"
              x2="1039.56"
              y2="775.86"
            />
            <path
              class="green"
              d="M1098.28,781.74c3.13,1.84-3.32,1.97-5.23,1.97c-1.91,0.01-1.67,2.87-1.1,3.7c0.36,0.55-5.05-1.1-8.89-2.31
    c-0.27-1.72-0.67-3.22-1.17-4.54c4.85-4.96,5.3-1.68,4.85-0.11c-0.52,1.79,3.31-1.98,6.01-4.88c2.68-2.89,0.88,0.04,0.25,2.21
    c-0.62,2.17,8.52-0.93,11.37-1.11C1107.21,776.5,1095.14,779.9,1098.28,781.74z"
            />
            <path
              class="green"
              d="M1119.77,845.94c-3.62,0.72-11.15-4.28-10.22-3.06c0.93,1.23,3.79,5.3,0.4,3.68
    c-3.38-1.61-8.53-5.84-7.36-3.64c1.17,2.22,2.25,4.89-1.97,2.04c-2.24-1.5-4.17-3.97-5.33-5.52c-1.04-1.37-1.46-2.02-0.91-0.59
    c0.16,0.42,0.35,0.87,0.53,1.31c1.12,2.74,2.35,5.53,0.26,3.84c-0.55-0.44-1.27-1.12-2.06-1.9c-1.72-1.69-3.72-3.86-4.88-5.14
    c0.07-1.21,0.01-2.32-0.08-3.24c4.35-0.52,12.45-1.35,11.55-0.25c-1.24,1.48,4.9,2.44,5.19,1.45c0.19-0.69,1.25,0.26,0.84,1.27
    v0.01c-0.18,0.45-0.64,0.91-1.58,1.25c-0.01,0.01-0.02,0.01-0.02,0.01c-0.32,0.12-0.44,0.2-0.42,0.25
    c0.15,0.42,10.84-1.2,7.97,1.21C1108.45,841.61,1123.39,845.22,1119.77,845.94z"
            />
            <path
              class="green"
              d="M1022.2,803.78c-21.48-4.94-29.26-15.12-29.26-15.12l3.41-2.76c8.16,10.63,19.37,14.23,25.77,15.44"
            />
            <path
              class="green"
              d="M1023.74,786.96c-0.64-3.13-1.65,1.53-1.32,3.55c-0.12-0.7-0.38-2.23-0.71-4.06
    c-0.27-1.54-0.59-3.29-0.91-4.91c-0.96-4.92-3.42-2.1-2.72-0.76c0.71,1.35-1.48,1.34-2.48-2.12c-1.02-3.46-5.99-7.2-5.66-5.17
    c0.33,2.02,0.73,6.97-1.18,7.32c-1.89,0.35,2.64,6.62,4.29,7.76c1.66,1.14-2.75-0.48-2.13,1.14c0.54,1.36,6.28,5.17,7.75,6.07
    c-1.04-0.29-3.23,0.54-1.7,1.26c1.01,0.47,3.33,2.65,5.15,4.3c0.43,0.39,0.84,0.75,1.19,1.05c0.26-0.25,0.54-0.49,0.85-0.72
    c0.33-0.25,0.69-0.47,1.08-0.69c0.32-0.17,0.63-0.31,0.94-0.42C1026.23,797.2,1024.28,789.63,1023.74,786.96z M1018.7,795.79
    c0.1,0.03,0.19,0.07,0.26,0.13c0.03,0.03,0.05,0.04,0.05,0.06C1018.99,795.97,1018.88,795.9,1018.7,795.79z"
            />
            <path
              class="green"
              d="M1022.42,790.51c0.03,0.16,0.04,0.27,0.06,0.34"
            />
            <path class="green" d="M1022.49,790.92c0,0,0,0-0.01-0.01" />
            <path
              class="green"
              d="M1022.42,790.51c0.03,0.16,0.04,0.27,0.06,0.34"
            />
            <path
              class="green"
              d="M1018.67,795.78c0.01,0,0.02,0,0.03,0.01C1018.69,795.79,1018.68,795.79,1018.67,795.78"
            />
            <path
              class="green"
              d="M1020.71,806.4c-2.12,0.87-4.11,2.46-5.38,5.21c-3.44,1.59-7.17,4.79-8.28,6.2c-1.69,2.13,0.5-4.39,1.22-5.36
    c0.72-0.96-6.33,1.34-8.78,3.25c-2.46,1.92-2.82,0.48-1.43-1.46c1.38-1.94-11.56-0.9-11.87-2.25c-0.3-1.35,6.95-2.6,9.03-1.84
    c2.08,0.75,0.13-2.07-1.05-4.33c-1.18-2.27,11.54,1.29,12.43,1.3c0.89,0.03-1.22-2.04-0.57-2.73
    C1006.46,803.93,1015.07,805.38,1020.71,806.4z"
            />
          </g>
        </g>
        {/* </Link> */}

        <Link to={linkPortatucas} onClick={handleClickPortatucas}>
          <g className="portatucas">
            <path
              class="green"
              d="M1531.48,228.28c-1.46,32.02-12.95,282.98-14.47,287.88c-1.63,5.24-20.38,24.77-56.38,14.77
		s-33.44-29.53-33.44-29.53l37.65-277.27c7.5,4.91,19.1,9.44,36.4,9.58C1513.34,233.81,1523.39,231.5,1531.48,228.28z"
            />
            <path
              class="green"
              d="M1585.38,188.56c-0.94,12.08-14.01,21.87-33.57,27.29c0,0,0,0-0.01,0c-11.77,3.26-25.87,4.94-41.11,4.57h-0.01
		c-3.13-0.07-6.31-0.23-9.52-0.48c-12.6-0.98-24.43-3.24-34.88-6.45c-26.81-8.21-44.62-22.62-43.45-37.6
		c1.27-16.33,24.69-28.48,56.37-31.29c-7.73,4.03-14.32,9.61-19.12,16.45c-10.6,15.09,14.63,26.71,32.13,31.05
		c27.41,6.79,66.5-8.44,63.16-22.18c-1.42-5.82-5.8-12.61-11.99-18.5c17.67,5.62,31.26,13.97,37.78,23.36
		c0.49,0.7,0.94,1.41,1.34,2.11c0.12,0.21,0.24,0.42,0.35,0.63c0.12,0.21,0.23,0.42,0.33,0.63
		C1584.88,181.54,1585.66,185.04,1585.38,188.56z"
            />
            <path
              class="green"
              d="M1534.71,226.9c-1.05,0.18-2.11,0.35-3.19,0.5c-15.15,2.22-32.59,1.9-51.16-2.01
		c-5.57-1.17-10.61-2.48-15.17-3.89c-2.29-0.7-4.45-1.44-6.5-2.19c-44.49-16.37-35.86-43.42-35.86-43.42
		c-1.17,14.98,16.64,29.39,43.45,37.6c10.45,3.21,22.28,5.47,34.88,6.45c3.21,0.25,6.39,0.41,9.52,0.48h0.01
		c15.24,0.37,29.34-1.31,41.11-4.57c0.01,0,0.01,0,0.01,0c19.56-5.42,32.63-15.21,33.57-27.29c0.28-3.52-0.5-7.02-2.2-10.41
		C1593.87,198.81,1571.67,220.5,1534.71,226.9z"
            />
            <path
              class="green"
              d="M1534.71,226.9c-1.04,0.47-2.11,0.93-3.23,1.38c-8.09,3.22-18.14,5.53-30.24,5.43
		c-17.3-0.14-28.9-4.67-36.4-9.58c-2.48-1.61-4.51-3.27-6.15-4.82c2.05,0.75,4.21,1.49,6.5,2.19c4.56,1.41,9.6,2.72,15.17,3.89
		c18.57,3.91,36.01,4.23,51.16,2.01C1532.6,227.25,1533.66,227.08,1534.71,226.9z"
            />
            <path
              class="green"
              d="M1492.21,192.1c-17.5-4.34-42.73-15.96-32.13-31.05c4.8-6.84,11.39-12.42,19.12-16.45
		c9.31-4.88,20.28-7.54,31.8-7.56c12.17-0.02,23.95,6.35,32.38,14.38c6.19,5.89,10.57,12.68,11.99,18.5
		C1558.71,183.66,1519.62,198.89,1492.21,192.1z"
            />
            <g className="texts">
              <g>
                <path
                  d="M1485.54,373.63c3.41,0.05,6.86,0.33,10.24,0.82c0.96,0.14,2,0.35,2.26,1.41c0.14,0.58-0.01,1.32-0.05,1.91
				c-0.04,0.63,0.05,1.65-0.35,2.19c-0.65,0.88-2.4,0.55-3.33,0.55c-0.59,0-0.82-0.11-1.08,0.36c-0.31,0.54-0.09,2.22-0.11,2.88
				c-0.02,0.52-0.31,1.93-0.11,2.4c0.24,0.55,0.67,0.47,1.3,0.58c1.13,0.21,2.35,0.31,2.65,1.64c0.22,0.97,0.17,3.26-0.48,4.07
				c-0.73,0.92-2.76,0.49-3.74,0.38c-3.3-0.35-6.65-0.72-9.91-1.39c-4.71-0.97-11.75-3.56-12.33-9.26
				c-0.77-7.53,10.08-8.18,15.05-8.65C1485.53,373.55,1485.53,373.59,1485.54,373.63z M1487.15,386.13c0.07-1.86,0.14-3.58,0.21-5.3
				c0.03-0.8-4.35-0.37-5.03-0.35c-1.01,0.04-4.04,0.16-4.2,1.7c-0.13,1.28,2.76,2.39,3.64,2.71
				C1483.51,385.52,1485.34,385.8,1487.15,386.13z"
                />
                <path
                  d="M1495.73,304.5c1.64-1.1,2.73-2.96,3.72-4.64c1.09-1.85,3.66-1.46,4.96,0.08c1.23,1.46,0.25,3.61-0.8,4.89
				c-1.4,1.71-3.62,2.55-5.11,4.17c0.99,0.06,1.98,0.11,2.97,0.17c0.76,0.05,2.05-0.08,2.58,0.62c0.44,0.59,0.25,1.66,0.22,2.33
				c-0.04,0.78-0.02,1.78-0.69,2.31c-0.61,0.48-1.52,0.34-2.24,0.32c-1.27-0.03-2.54-0.1-3.81-0.17c-2.44-0.15-4.88-0.3-7.32-0.48
				c-2.45-0.18-4.9-0.4-7.35-0.63c-1.12-0.1-2.25-0.19-3.37-0.32c-0.82-0.09-1.96-0.11-2.31-1.02c-0.31-0.8-0.07-2.02,0.01-2.85
				c0.11-1.17,0.31-2.34,0.64-3.47c0.56-1.9,1.43-3.76,2.87-5.15c3.1-3,8.32-3.2,11.92-0.95
				C1494.38,300.8,1495.42,302.34,1495.73,304.5z M1490.44,308.36c0.63,0.02,0.63,0.02,0.56-0.8c-0.01-0.09-0.01-0.18-0.02-0.28
				c-0.24-1.89-1.75-3.27-3.61-3.29c-1.98-0.02-3.29,1.11-3.61,3.13c-0.1,0.64-0.09,0.69,0.57,0.75
				C1486.32,308.04,1488.3,308.19,1490.44,308.36z"
                />
                <path
                  d="M1493.74,296.19c-4.48-0.04-9.18-1.41-12.3-4.82c-3.17-3.47-3.04-8.27,0.5-11.41c3.61-3.2,8.9-3.9,13.49-3.07
				c4.14,0.76,8.89,3.03,10.57,7.19c2.14,5.32-2.15,9.78-6.91,11.32C1497.24,296,1495.33,296.14,1493.74,296.19z M1493.76,290.06
				c2.04-0.05,3.92-0.54,5.57-1.79c2.57-1.94-0.56-4.43-2.36-5.23c-2.42-1.08-5.27-1.24-7.8-0.42c-2,0.64-4.63,2.43-2.72,4.7
				C1488.27,289.5,1491.17,289.68,1493.76,290.06z"
                />
                <path
                  d="M1494.1,322.73c1.7-1.56,2.6-3.65,4.13-5.32c1.12-1.22,3.2-0.43,4.28,0.5c1.47,1.27,0.62,3.49-0.37,4.84
				c-1.36,1.85-3.65,2.92-5.36,4.41c1.03,0.06,2.06,0.11,3.09,0.18c0.85,0.06,2.13-0.05,2.63,0.81c0.43,0.75,0.16,2.01,0.06,2.81
				c-0.13,1.04-0.45,1.79-1.57,1.94c-2.51,0.32-5.32-0.17-7.84-0.33c-2.65-0.16-5.3-0.35-7.95-0.58c-2.69-0.23-5.51-0.26-8.16-0.77
				c-2.15-0.41-1.61-2.46-1.41-4.19c0.49-4.29,2.39-8.71,6.75-10.16c4.14-1.38,10.79,0.31,11.58,5.28
				C1493.97,322.29,1494.02,322.43,1494.1,322.73z M1488.73,326.5c0.61,0.01,0.63,0.01,0.64-0.39c0.05-2.92-2.66-4.63-5.18-3.69
				c-1.38,0.51-1.91,1.68-2.12,3.05c-0.07,0.44,0.2,0.53,0.53,0.56C1484.61,326.19,1486.62,326.34,1488.73,326.5z"
                />
                <path
                  d="M1488.16,353.5c-4.91,0-10.72-2.03-13.28-6.53c-2.44-4.29-0.07-8.81,3.92-11.01c4.54-2.51,10.39-2.43,15.11-0.47
				c4.01,1.67,8.08,5.28,7.23,10.11c-0.46,2.58-2.45,4.71-4.63,5.98c-2.57,1.5-5.45,1.68-8.33,2.03
				C1488.17,353.57,1488.16,353.54,1488.16,353.5z M1488.24,347.36c2.24,0.03,4-0.48,5.6-1.56c2.41-1.63,0.31-4.07-1.5-5.02
				c-2.41-1.27-5.12-1.5-7.74-0.88c-2.25,0.53-5.47,2.39-3.25,4.95C1483.03,346.79,1485.83,347.25,1488.24,347.36z"
                />
                <path
                  d="M1488.35,420.05c1.4,0.16,3.44-0.18,4.75,0.38c1.28,0.54,0.92,2.35,0.79,3.48c-0.18,1.52-0.76,1.78-2.24,1.77
				c-1.89-0.01-3.77-0.09-5.66-0.19c-3.53-0.2-7.05-0.48-10.56-0.78c-1.71-0.14-3.43-0.27-5.14-0.46c-0.94-0.1-2.83-0.01-3.27-1.04
				c-0.21-0.5-0.01-1.24,0.05-1.76c0.09-0.88,0.21-1.75,0.33-2.63c0.24-1.69,0.65-3.24,1.51-4.73c1.31-2.25,3.32-3.91,5.89-4.42
				c2.78-0.55,6-0.02,8.27,1.73c1.31,1.01,1.65,2.14,2.28,3.58c0.25,0.56,0.18,0.63,0.71,0.22c0.68-0.53,1.28-1.57,1.81-2.25
				c0.79-1.02,1.5-3.06,2.92-3.14c1.37-0.08,3.4,0.75,3.81,2.18c0.39,1.38-0.56,3.19-1.46,4.15c-1.4,1.51-3.38,2.37-4.86,3.78
				C1488.32,419.96,1488.34,420.01,1488.35,420.05z M1473.59,418.46c-0.08,0.33,0.11,0.46,0.52,0.48c1.14,0.06,2.29,0.17,3.43,0.27
				c0.82,0.07,1.92,0.4,2.7,0.25c1.41-0.27,0.17-2.67-0.5-3.3C1477.43,413.99,1473.94,415.39,1473.59,418.46z"
                />
                <path
                  d="M1480.4,446.02c-4.67-0.02-9.38-1.2-12.68-4.74c-3.55-3.81-2.55-8.93,1.52-11.85c4.16-2.97,10.05-3.19,14.78-1.66
				c4.17,1.35,8.77,4.57,8.61,9.5c-0.18,5.61-6.57,8.49-11.4,8.7C1480.95,445.98,1480.67,446,1480.4,446.02z M1480.03,439.96
				c0.18,0,0.37,0,0.55,0c2.01-0.04,6.96-1.37,5.59-4.34c-1.15-2.48-4.95-3.35-7.39-3.34c-2.06,0.01-7.88,1.07-6.48,4.36
				C1473.46,439.37,1477.49,439.88,1480.03,439.96z"
                />
                <path
                  d="M1471.73,367.73c0.12-4.55,1.56-9.71,5.94-11.86c4.24-2.08,10.38-1.31,13.59,2.32c1.86,2.11,1.98,4.31,1.8,6.99
				c-0.04,0.58-0.14,0.7,0.38,0.93c0.48,0.22,1.38,0.12,1.91,0.17c0.93,0.09,2.82-0.05,3.43,0.82c0.53,0.76,0.07,2.37-0.02,3.21
				c-0.11,1.01-0.26,1.75-1.37,1.94c-1.22,0.2-2.64-0.1-3.86-0.22c-1.59-0.15-3.19-0.31-4.78-0.46c-3.33-0.33-6.66-0.67-9.99-0.96
				c-1.6-0.14-3.17-0.24-4.77-0.21c-1.11,0.02-1.98,0.04-2.15-1.26C1471.78,368.61,1471.76,368.07,1471.73,367.73z M1486.03,363.47
				c0.08-1.64-0.52-2.5-1.86-2.81c-1.17-0.27-2.37-0.22-3.37,0.52c-0.45,0.33-0.83,0.76-1.01,1.3c-0.12,0.34-0.44,1.58-0.28,1.88
				c0.38,0.7,3.26,0.54,4.09,0.61c0.45,0.04,1.81,0.41,2.16,0.11C1486.07,364.82,1485.99,363.87,1486.03,363.47z"
                />
                <path
                  d="M1484.69,455.56c-0.07,0.75-0.62,2.51,0.1,2.89c0.46,0.25,1.65,0.14,2.16,0.19c0.72,0.07,1.49,0.08,2.2,0.23
				c0.93,0.19,1.2,0.63,1.21,1.55c0.01,0.89,0.06,2.93-0.55,3.63c-0.67,0.77-2.17,0.49-3.03,0.41c-1.53-0.14-3.06-0.3-4.59-0.45
				c-2.93-0.29-5.87-0.57-8.8-0.84c-2.77-0.26-5.49-0.37-8.26-0.47c-1.13-0.04-1.63-0.36-1.75-1.52c-0.14-1.39-0.02-2.87,0.22-4.25
				c0.81-4.66,3.52-8.53,8.3-9.46c4.97-0.97,11.66,1.31,12.68,6.9C1484.66,454.75,1484.66,455.12,1484.69,455.56z M1471.04,457.02
				c2.17,0.19,4.24,0.37,6.38,0.55c0.05-1.06,0.39-2.46-0.14-3.45c-0.52-0.97-1.69-1.11-2.67-1.13
				C1471.91,452.92,1471.35,454.71,1471.04,457.02z"
                />
                <path
                  d="M1475.09,401.79c-0.1,1.19,0.16,3.48-0.58,4.5c-0.64,0.87-2.39,0.41-3.27,0.36c-1.35-0.07-2.35-0.2-2.51-1.72
				c-0.18-1.81-0.02-3.69,0.11-5.5c0.13-1.78,0.29-3.56,0.46-5.34c0.11-1.2,0.11-3.05,1.58-3.34c0.79-0.16,1.76,0.07,2.56,0.15
				c0.51,0.05,1.44,0,1.86,0.35c0.51,0.43,0.35,1.32,0.35,1.91c0,0.97,0,1.94,0,2.91c4.09,0.27,8.19,0.59,12.29,0.81
				c2,0.11,4.07,0.03,6.04,0.4c0.67,0.13,1.69,0.23,2.06,0.92c0.3,0.56,0.07,1.58,0.01,2.18c-0.11,1.2-0.2,2.7-1.65,2.86
				c-1.89,0.21-4.1-0.33-6-0.49c-4.15-0.37-8.3-0.65-12.46-0.93C1475.67,401.77,1475.41,401.79,1475.09,401.79z"
                />
              </g>
            </g>
          </g>
        </Link>
        <Link to={linkFiltros} onClick={handleClickFiltros}>
          <g className="filtros">
            <path
              class="green"
              d="M1051.48,487.75l-2.85,37.18c-10,4-239,8-239,8l-3-34L1051.48,487.75z"
            />
            <path
              class="green"
              d="M1051.48,487.75l-244.85,11.18l4.61-61.15c0,0,229.39-7.85,234.39-9.85L1051.48,487.75z"
            />
            <path class="green" d="M944.63,502.93c1,0,91-6,96-7" />
            <path class="green" d="M837.63,516.93c0,0,79.85-1.43,91.43-2.71" />
            <path class="green" d="M1003.36,521.02c0,0,36.27,0.91,39.27-2.09" />
            <g className="texts">
              <g>
                <path d="M854.24,453.47c0.04,0.49,0.11,0.97,0.11,1.46c0,0.62-0.07,1.24-0.11,1.86C854.24,455.68,854.24,454.57,854.24,453.47z" />
                <path d="M993.66,445.89c-0.49,0.03-0.98,0.09-1.46,0.1c-0.36,0-0.72-0.06-1.08-0.1C991.97,445.89,992.81,445.89,993.66,445.89z" />
                <path
                  d="M935.86,470.06c0.18,1.26,0.31,2.49,0.35,3.76c0.04,1.35,0.07,2.19-1.43,2.45c-1.3,0.23-2.65,0.36-3.97,0.23
				c-1.45-0.14-1.77-0.81-1.96-2.14c-0.85-5.81-1.02-11.79-1.25-17.65c-0.05-1.39-0.09-2.77-0.12-4.16
				c-0.02-0.97-0.37-2.64,0.41-3.44c0.67-0.69,2.1-0.6,2.98-0.67c1.51-0.11,3.02-0.1,4.53,0.01c4.71,0.33,10.36,1.59,12.44,6.38
				c1.04,2.39,0.94,5.36-0.26,7.67c-1.28,2.46-3.51,3.44-6.03,4.23c2.15,1.62,4.74,2.35,7.24,3.28c1.86,0.7,1.75,2.81,0.71,4.28
				c-1.43,2.01-4.08,1.66-6.16,0.94c-2.54-0.87-4.56-2.96-6.63-4.59C936.46,470.45,936.18,470.28,935.86,470.06z M935.33,454.93
				c-0.02,0.05-0.04,0.07-0.04,0.09c0.05,1.17,0.09,2.34,0.14,3.51c0.04,1.01-0.14,2.34,0.14,3.31c0.38,1.35,3.35-0.24,4.01-0.84
				c1.27-1.15,1.75-2.95,0.7-4.43C939.25,455.12,937,454.62,935.33,454.93z"
                />
                <path
                  d="M965.17,475.45c-11.04,0.09-16.44-13.73-11-22.27c2.75-4.31,7.61-6.78,12.73-5.91c4.7,0.8,8.28,4.13,10.06,8.44
				c2.26,5.45,0.95,12.15-3.28,16.3C971.34,474.32,968.45,475.4,965.17,475.45z M960.34,461.76c-0.03,2.22,0.97,4.3,2.8,6.02
				c2.38,2.24,5.26,0.56,6.58-1.87c1.36-2.5,1.33-5.64,0.08-8.17c-1.16-2.34-3.65-4.85-6.44-3.22
				C960.91,455.94,960.24,459.17,960.34,461.76z"
                />
                <path
                  d="M992.4,446.07c2.35,0.22,4.41,0.58,6.48,1.81c1.65,0.99,3.82,2.69,3.75,4.81c-0.06,2.01-2.13,3.74-4.04,4.04
				c-2.62,0.42-3.13-2.69-4.83-3.93c-1.4-1.03-3.95-0.87-4.1,1.29c-0.08,1.15,0.77,1.67,1.64,2.22c1.18,0.74,2.45,1.35,3.69,1.98
				c2.11,1.07,4.55,1.96,6.15,3.78c1.2,1.37,1.83,3.16,1.73,4.97c-0.25,4.4-4.63,7.08-8.69,7.44c-4.54,0.39-10.18-1.48-12.75-5.42
				c-1.2-1.85-1.21-3.74,0.52-5.25c1.34-1.16,3.76-1.77,5.21-0.46c0.82,0.75,1.22,1.84,1.93,2.68c0.61,0.72,1.4,1.24,2.33,1.47
				c1.68,0.42,4.06-0.16,3.09-2.35c-0.55-1.24-2.02-1.82-3.15-2.41c-1.22-0.63-2.49-1.16-3.73-1.76c-2.16-1.04-4.67-2.6-5.82-4.77
				c-1.1-2.07-0.71-4.71,0.74-6.52c1.63-2.03,4.17-2.99,6.69-3.34C990.28,446.19,991.36,446.15,992.4,446.07z"
                />
                <path
                  d="M854.47,456.96c0-1.33-0.34-3.15,0.19-4.39c0.63-1.46,2.28-1.8,3.72-1.94c3.65-0.37,7.55-0.71,11.22-0.44
				c1.52,0.11,2.79,0.12,3.03,1.87c0.17,1.24,0.6,3.31-0.39,4.31c-0.95,0.96-2.84,0.69-4.07,0.73c-0.88,0.03-1.77,0.06-2.65,0.09
				c-0.76,0.03-1.74-0.05-2.44,0.3c-1.31,0.66-0.97,2.56-0.72,3.71c0.16,0.72,0.22,1.17,1.01,1.25c0.87,0.09,1.84-0.09,2.72-0.15
				c0.84-0.05,1.68-0.12,2.52-0.14c0.64-0.01,1.89-0.15,2.38,0.32c0.48,0.47,0.41,1.65,0.48,2.26c0.08,0.78,0.3,1.84-0.01,2.59
				c-0.57,1.39-2.88,1.17-4.08,1.23c-0.9,0.04-1.82,0.05-2.72,0.13c-0.52,0.05-0.73,0.01-0.82,0.53c-0.12,0.7,0.09,1.56,0.15,2.26
				c0.07,0.94,0.15,1.89,0.22,2.83c0.09,1.17,0.38,2.86-0.67,3.73c-1.12,0.93-3.33,0.59-4.67,0.59c-1.84-0.01-2.74-0.86-3.11-2.65
				c-0.42-2.03-0.45-4.19-0.63-6.25c-0.18-2.09-0.32-4.19-0.41-6.29C854.62,461.51,854.56,459.56,854.47,456.96z"
                />
                <path
                  d="M897.99,470.28c1.48-0.08,2.96-0.12,4.44-0.14c1.15-0.01,2.85-0.42,3.5,0.78c0.62,1.15,0.68,2.64,0.48,3.91
				c-0.21,1.41-0.96,1.96-2.35,2.12c-2.92,0.34-5.87,0.51-8.8,0.63c-2.37,0.09-5.54,0.41-6.32-2.38c-0.82-2.96-0.69-6.29-0.88-9.34
				c-0.19-3.02-0.37-6.04-0.55-9.07c-0.09-1.54-0.19-3.08-0.26-4.61c-0.06-1.14,0-2.33,1.37-2.52c1.38-0.2,2.84-0.15,4.23-0.21
				c1.02-0.04,2.73-0.46,3.4,0.59c0.3,0.47,0.28,1.11,0.34,1.63c0.09,0.89,0.17,1.79,0.26,2.68c0.15,1.69,0.29,3.38,0.42,5.07
				c0.27,3.57,0.49,7.13,0.7,10.7C897.96,470.16,897.98,470.21,897.99,470.28z"
                />
                <path
                  d="M918.5,455.34c0.2,3.42,0.39,6.83,0.66,10.24c0.13,1.68,0.28,3.36,0.42,5.04c0.13,1.56,0.53,3.37,0.03,4.9
				c-0.49,1.5-1.84,1.33-3.18,1.37c-1.24,0.03-3.43,0.38-4.41-0.63c-0.42-0.43-0.3-1.26-0.33-1.81c-0.05-0.9-0.08-1.8-0.1-2.7
				c-0.05-1.66-0.09-3.33-0.16-4.99c-0.07-1.91-0.18-3.83-0.29-5.74c-0.11-1.77-0.05-3.68-0.43-5.41c-1.62,0.07-3.26,0.21-4.88,0.17
				c-1.08-0.03-1.81-0.26-2.05-1.39c-0.15-0.73-0.18-1.5-0.22-2.25c-0.03-0.55-0.16-1.31,0.12-1.83c0.54-0.98,2.56-1.03,3.51-1.12
				c3.38-0.31,6.77-0.52,10.16-0.61c1.62-0.04,3.25-0.07,4.87-0.03c1.33,0.04,2.61,0.26,2.8,1.76c0.1,0.83,0.09,1.68,0.13,2.52
				c0.03,0.69,0.13,1.33-0.53,1.75c-0.72,0.46-1.91,0.39-2.74,0.46c-1.01,0.09-2.02,0.17-3.03,0.25
				C918.74,455.29,918.64,455.31,918.5,455.34z"
                />
                <path
                  d="M875.98,462.07c-0.04-2.45-0.08-4.9-0.12-7.34c-0.02-1.17-0.2-2.51,0.04-3.66c0.22-1.06,1.37-1.12,2.28-1.14
				c1.18-0.03,2.36-0.04,3.54-0.06c0.92-0.01,2.08-0.17,2.52,0.81c0.42,0.95,0.26,2.33,0.3,3.35c0.06,1.32,0.11,2.63,0.17,3.95
				c0.21,5.08,0.47,10.17,0.62,15.25c0.03,0.99,0.21,2.13,0,3.11c-0.26,1.18-1.17,1.32-2.22,1.39c-1.13,0.08-2.27,0.16-3.41,0.17
				c-0.87,0.01-1.79,0.01-2.47-0.61c-0.76-0.69-0.73-1.74-0.78-2.68c-0.07-1.38-0.12-2.75-0.17-4.13c-0.1-2.81-0.24-5.62-0.24-8.42
				C876.02,462.07,876,462.07,875.98,462.07z"
                />
              </g>
            </g>
          </g>
        </Link>
        <Link to={linkPikas} onClick={handleClickPikas}>
          <g className="pikas">
            <g>
              <path
                class="green"
                d="M1304.56,713.95l14.09-30.14l6.43,5.63c-0.59,17.01,5.14,33.68,17.04,49.57
			c14.68,19.61,38.94,38.17,72.09,55.19c22.78,11.69,46.37,17.61,70.11,17.61c0,0,0.01,0,0.01,0c37.79,0,73.19-15.2,97.27-41.75
			l10.77-0.51l-13.71,41.9l-164.77,3.95L1304.56,713.95z"
              />
              <path
                d="M1319.34,687.07l3.72,3.26c-0.86,38.94,29.49,74.48,90.25,105.65c16.21,8.31,32.83,13.75,49.62,16.25l-48.27,1.16
			l-107.67-99.91L1319.34,687.07 M1589.57,771.7l-12.37,37.8l-65.04,1.56c27.29-5.51,52-19.06,70.36-39.02L1589.57,771.7
			 M1317.97,680.56l-15.84,33.87l111,103l167-4l15.05-46l-14.5,0.69c-22.26,24.88-56.98,41.7-96.35,41.7
			c-22.06,0-45.59-5.29-69.2-17.39c-71.63-36.75-89.45-74.25-88.01-103.85L1317.97,680.56L1317.97,680.56z"
              />
            </g>
            <g>
              <path
                class="green"
                d="M1484.33,808.82c-23.25,0-46.38-5.81-68.74-17.28c-32.75-16.8-56.66-35.08-71.06-54.32
			c-11.2-14.96-16.74-30.59-16.47-46.5l97.42,85.46c0.18,0.16,0.42,0.25,0.66,0.25c0.02,0,152.18-7.2,152.18-7.2
			C1554.82,794.42,1520.72,808.82,1484.33,808.82z"
              />
              <path
                d="M1329.05,692.93l95.76,84c0.37,0.32,0.83,0.5,1.32,0.5c0.03,0,0.06,0,0.09,0l149.63-7.08
			c-10.52,10.77-23.48,19.75-37.75,26.12c-16.86,7.53-34.96,11.35-53.78,11.35c-23.09,0-46.07-5.78-68.28-17.17
			c-32.61-16.73-56.41-34.91-70.72-54.03C1334.77,722.53,1329.31,707.85,1329.05,692.93 M1327.12,688.58
			c-1.44,29.6,16.38,67.1,88.01,103.85c23.61,12.11,47.13,17.39,69.2,17.39c39.37,0,74.1-16.82,96.35-41.7l-154.55,7.31
			L1327.12,688.58L1327.12,688.58z"
              />
            </g>
            <polygon
              class="green"
              points="1598.25,758.02 1595.18,767.43 1580.68,768.12 1426.13,775.43 1428.13,767.43 1588.3,758.57 	"
            />
            <polygon
              class="green"
              points="1413.13,817.43 1411.13,824.43 1302.13,722.26 1302.13,714.43 	"
            />
            <polygon
              class="green"
              points="1580.13,813.43 1577.13,819.43 1411.13,824.43 1413.13,817.43 	"
            />
            <g>
              <polygon
                class="green"
                points="1312.74,663.46 1361.37,569.37 1510.5,562.46 1631.54,653.16 1596.79,756.09 1428.83,765.38 		"
              />
              <path
                d="M1509.88,564.49l119.3,89.4l-33.85,100.28l-7.25,0.4l-158.54,8.77l-98.75-86.7l-6.91-6.07l-8.64-7.59l47.38-91.67
			L1509.88,564.49 M1511.13,560.43l-151,7l-49.88,96.5l10.99,9.65l6.91,6.07l99.98,87.78l160.17-8.86l9.95-0.55l0.1-0.28
			l35.55-105.31L1511.13,560.43L1511.13,560.43z"
              />
            </g>
            <g>
              <polygon
                class="green"
                points="1327.78,687.82 1318.63,679.8 1311.25,673.32 1311.25,666.14 1427.01,767.78 1425.56,773.59 		"
              />
              <path
                d="M1312.25,668.34l7.67,6.73l6.91,6.07l99.06,86.98l-0.91,3.64l-96.55-84.69l-9.15-8.02l-7.04-6.18V668.34 M1310.25,663.93
			v9.85l7.72,6.78l9.15,8.02l99.01,86.85l2-8l-99.98-87.78l-6.91-6.07L1310.25,663.93L1310.25,663.93z"
              />
            </g>
            <g className="texts">
              <g>
                <path
                  d="M1414.76,654.74c0.47-0.54,0.67-1.53,0.93-2.19c0.33-0.83,0.66-1.66,0.99-2.48c0.65-1.62,1.31-3.23,1.98-4.84
				c1.3-3.15,2.56-6.31,3.81-9.48c0.64-1.63,1.36-3.24,1.93-4.9c0.26-0.76,0.48-1.52,0.65-2.3c0.16-0.71,0.25-1.57,0.9-2.03
				c1.08-0.78,3.27,0.17,4.39,0.51c1.56,0.48,3.09,1.07,4.53,1.83c2.61,1.38,5.11,3.26,6.64,5.83c1.52,2.56,1.83,5.69,1.22,8.57
				c-1.19,5.7-5.99,10.9-12.08,10.98c-1.93,0.02-3.65-0.7-5.43-1.33c-0.25-0.09-0.76-0.39-1.02-0.25c-0.24,0.13-0.36,0.79-0.45,1.03
				c-0.37,0.94-0.74,1.88-1.12,2.81c-0.59,1.45-1.16,3.11-3.02,2.48c-0.94-0.32-1.86-0.67-2.79-1.02c-0.73-0.28-1.67-0.47-2.08-1.21
				C1414.76,656.08,1414.76,655.41,1414.76,654.74z M1427.78,644.36c0.89,0.31,1.69,0.56,2.47,0.86c1.24,0.47,2.64,0.38,3.54-0.66
				c0.76-0.89,1.26-1.98,1.25-3.16c0-1-0.3-2-1-2.73c-0.88-0.91-2.2-1.22-3.37-1.58C1429.71,639.52,1428.75,641.93,1427.78,644.36z"
                />
                <path
                  d="M1502.37,662.58c-0.03,4.04-1.17,7.95-2.49,11.73c-0.66,1.89-1.4,3.75-2.18,5.59c-0.36,0.85-0.71,1.7-1.1,2.53
				c-0.38,0.82-0.75,1.8-1.45,2.41c-0.65,0.57-1.25,0.52-2.03,0.28c-0.98-0.31-1.96-0.62-2.94-0.93c-0.7-0.22-1.55-0.42-1.91-1.14
				c-0.38-0.73,0.08-1.74,0.27-2.46c0.13-0.49,0.26-0.98,0.39-1.47c0.06-0.21,0.36-0.83,0.26-1.04c-0.11-0.24-0.42-0.26-0.66-0.34
				c-0.58-0.18-1.16-0.35-1.74-0.53c-0.96-0.29-1.93-0.58-2.89-0.88c-0.49-0.15-1.97-0.87-2.42-0.56c-0.25,0.18-0.46,0.85-0.61,1.14
				c-0.21,0.41-0.39,0.83-0.59,1.24c-0.34,0.66-0.86,1.2-1.59,1.42c-1.53,0.45-3.42-0.56-4.81-1.11c-1.69-0.66-1.84-1.91-1.21-3.5
				c0.76-1.94,1.52-3.88,2.33-5.8c1.5-3.59,3.25-7.07,5.44-10.29c1.99-2.92,4.43-5.68,7.63-7.29c3.27-1.64,7.45-2.08,10.51,0.27
				c3.35,2.58,3.58,6.86,3.89,10.72C1502.43,662.57,1502.4,662.58,1502.37,662.58z M1491.39,670.96c0.05-0.12,0.08-0.21,0.11-0.29
				c0.94-2.76,2.13-5.76,1.91-8.73c-0.06-0.84-0.32-2.36-1.36-2.54c-1.08-0.19-2.27,0.93-2.94,1.63c-1.88,1.97-3.4,4.28-4.56,6.74
				c-0.09,0.19-0.43,0.69-0.38,0.91c0.06,0.26,0.59,0.3,0.79,0.36c0.68,0.2,1.35,0.4,2.03,0.6
				C1488.46,670.06,1489.93,670.51,1491.39,670.96z"
                />
                <path
                  d="M1460.68,659.58c-0.56,0.93-0.9,2.05-1.31,3.06c-0.44,1.09-0.85,2.19-1.29,3.28c-0.42,1.05-0.88,2.08-1.45,3.06
				c-0.47,0.8-1.18,2.06-2.23,2.13c-1.01,0.07-2.3-0.55-3.25-0.87c-0.86-0.29-1.92-0.72-2.3-1.62c-0.39-0.93,0.23-1.96,0.6-2.79
				c0.49-1.11,0.98-2.22,1.46-3.33c1.94-4.48,3.77-8.99,5.48-13.57c0.85-2.27,1.69-4.53,2.57-6.78c0.38-0.97,0.69-2.03,1.18-2.95
				c0.56-1.04,1.56-0.9,2.54-0.6c1.58,0.49,5.04,1.07,4.61,3.36c-0.48,2.55-1.89,4.86-2.53,7.36c2.53-0.83,4.75-2,7.02-3.39
				c1.15-0.7,2.3-1.55,3.54-2.09c0.98-0.43,1.9-0.32,2.63,0.49c0.85,0.94,1.42,2.17,1.81,3.37c0.35,1.07,0.22,1.92-0.69,2.63
				c-2.07,1.62-4.48,2.61-6.88,3.63c-1.28,0.54-2.56,1.08-3.84,1.62c-0.28,0.12-0.73,0.21-0.84,0.53c-0.14,0.41,0.17,1.15,0.24,1.56
				c0.49,2.72,0.98,5.44,1.49,8.16c0.25,1.37,0.51,2.73,0.76,4.1c0.2,1.08,0.77,2.65,0.33,3.72c-0.42,1.02-1.75,1.25-2.72,1.41
				c-1.24,0.2-2.53,0.19-3.72-0.22c-2.47-0.86-1.95-3.94-2.05-6.04c-0.14-3.1-0.47-6.13-1.07-9.17
				C1460.72,659.6,1460.7,659.59,1460.68,659.58z"
                />
                <path
                  d="M1528.52,668.61c0,1.26-0.04,2.22-0.95,3.19c-0.84,0.89-1.92,1.48-3.1,1.76c-1.08,0.26-2.35,0.2-3.13-0.69
				c-0.73-0.84-0.69-2.16-0.83-3.2c-0.16-1.19-0.33-2.58-1.38-3.36c-0.79-0.59-1.98-0.43-2.73,0.15c-0.64,0.48-1.01,1.28-1.03,2.08
				c-0.02,1.02,0.67,1.88,1.21,2.7c1.52,2.33,3.51,4.38,4.9,6.79c1.34,2.32,1.53,4.93,0.62,7.44c-1.65,4.57-6.45,7.21-11.24,6.2
				c-4.52-0.95-8.46-4.83-9.71-9.25c-0.34-1.22-0.41-2.52-0.21-3.77c0.19-1.22,0.91-2.12,1.9-2.84c1.71-1.26,4.96-1.66,6,0.69
				c0.51,1.15,0.3,2.51,0.54,3.72c0.19,0.96,0.69,1.83,1.44,2.47c0.77,0.66,1.87,1.23,2.88,0.72c0.94-0.48,1.2-1.65,1.1-2.62
				c-0.14-1.29-1.06-2.32-1.79-3.33c-0.79-1.11-1.63-2.17-2.47-3.24c-1.45-1.85-2.88-4.26-3.12-6.64c-0.46-4.51,3.22-8.74,7.71-9.12
				c2.5-0.21,5.11,0.27,7.38,1.33c2.31,1.08,4.03,2.94,5.19,5.2c0.62,1.2,0.78,2.3,0.94,3.62
				C1528.58,668.6,1528.55,668.6,1528.52,668.61z"
                />
                <path
                  d="M1457.49,638.04c-0.68,2.57-1.86,5.04-2.82,7.52c-1,2.59-1.98,5.19-2.99,7.77c-0.98,2.51-1.92,5.04-2.92,7.54
				c-0.51,1.27-1.02,2.53-1.54,3.79c-0.39,0.95-0.73,2.38-1.75,2.85c-0.98,0.45-2.42-0.22-3.37-0.51c-1.02-0.32-2.23-0.66-3.04-1.39
				c-0.79-0.71-0.91-1.72-0.59-2.69c0.44-1.32,0.94-2.62,1.44-3.92c1.99-5.15,4.05-10.28,6.12-15.4c0.59-1.45,1.19-2.91,1.8-4.35
				c0.55-1.27,0.97-2.77,1.73-3.94c0.73-1.12,1.78-0.7,2.84-0.33c1.49,0.52,3,1.06,4.41,1.78
				C1457.33,637.04,1457.5,637.35,1457.49,638.04z"
                />
              </g>
            </g>
          </g>
        </Link>
        <Link to={linkSedas} onClick={handleClickSedas}>
          <g className="sedas">
            <polygon
              class="green"
              points="1265.13,674.43 1265.13,698.74 785.13,692.43 780.13,671.43 	"
            />
            <path
              class="green"
              d="M1265.13,674.43l-485-3c0,0,2-70,12-94c0.9-2.17,2.1-3.79,3.55-4.93l-11.55,70.93c0,0,215-1,254-2s117,6,160,6
		c24.93,0,46.02-1.03,59.34-1.89L1265.13,674.43z"
            />
            <path
              class="green"
              d="M1272.71,644.38c0,0-5.58,0.54-15.24,1.16c-13.32,0.86-34.41,1.89-59.34,1.89c-43,0-121-7-160-6s-254,2-254,2
		l11.55-70.93l1.31-8.07c7.85-1,197.14-2,234.29,0c37.16,2,213.85,0,213.85,0C1262.13,636.43,1272.71,644.38,1272.71,644.38z"
            />
            <g className="texts">
              <g>
                <path
                  d="M1064.64,586.45c-0.21,0.02-0.42,0.06-0.63,0.06c-0.48-0.01-0.95-0.04-1.43-0.06
				C1063.26,586.45,1063.95,586.45,1064.64,586.45z"
                />
                <path
                  d="M1048.85,607.29c-0.07,1.47-0.12,2.95-0.2,4.42c-0.08,1.46-0.24,2.88-1.94,3.06c-1.56,0.16-3.51,0.45-5.05,0.06
				c-1.4-0.35-1.23-2.18-1.37-3.31c-0.03-0.25,0.03-0.95-0.16-1.13c-0.19-0.19-0.65-0.07-0.88-0.06c-0.86,0.04-1.72,0.07-2.58,0.1
				c-0.88,0.03-1.75,0.07-2.63,0.1c-0.44,0.02-0.88,0.03-1.31,0.05c-0.56,0.03-0.61,0.04-0.7,0.6c-0.19,1.28-0.08,2.82-1.43,3.49
				c-1.34,0.67-3.37,0.45-4.82,0.34c-1.43-0.11-2.24-0.72-2.25-2.18c-0.01-1.75,0-3.51,0.06-5.26c0.11-3.24,0.44-6.54,1.32-9.67
				c0.8-2.89,2.09-5.78,4.35-7.84c2.34-2.13,5.44-3.42,8.64-3.13c7.19,0.64,10.11,8.88,10.65,14.96
				C1048.75,603.86,1048.78,605.84,1048.85,607.29z M1039.59,602.96c-0.12-1.62-0.24-3.23-0.71-4.8c-0.44-1.47-1.97-4.43-3.81-2.73
				c-1.47,1.36-2.18,3.61-2.6,5.51c-0.22,0.99-0.48,2.15-0.43,3.16c0.03,0.56,0.36,0.39,0.87,0.37c0.53-0.02,1.06-0.05,1.59-0.07
				c1.16-0.05,2.31-0.09,3.47-0.15c0.34-0.02,1.21,0.09,1.49-0.1C1039.74,603.96,1039.59,603.28,1039.59,602.96z"
                />
                <path
                  d="M999.77,607.6c-0.22-5.91-0.44-11.87-0.27-17.78c0.03-1.06-0.2-2.31,1.04-2.66c1.37-0.39,2.92-0.46,4.34-0.45
				c2.85,0.02,5.83,0.56,8.45,1.72c4.25,1.87,7.04,5.53,7.67,10.12c0.37,2.7,0.05,5.65-0.9,8.2c-0.9,2.4-2.69,4.4-4.82,5.8
				c-2.49,1.63-5.41,2.35-8.36,2.47c-1.55,0.06-3.32,0.1-4.81-0.36c-1.21-0.38-2.58-1.38-2.51-2.78
				C999.66,610.52,999.71,609.16,999.77,607.6z M1007.72,602.53c-0.06,1.45-0.13,3.1-0.21,4.75c-0.04,0.87,2.41-0.16,2.76-0.37
				c0.88-0.54,1.51-1.37,1.93-2.3c1.07-2.41,1.13-5.84,0.16-8.28c-0.41-1.03-1.08-1.96-2.1-2.45c-0.6-0.29-1.26-0.38-1.92-0.39
				c-0.66-0.01-1.09-0.14-1.01,0.6C1007.58,596.89,1007.71,599.7,1007.72,602.53z"
                />
                <path
                  d="M965.91,615.11c-4.03-0.16-8.62-1.74-11.13-5.06c-1.4-1.86-1.75-4.05,0.06-5.73c1.31-1.22,3.8-2.01,5.33-0.68
				c0.81,0.7,1.16,1.76,1.75,2.61c0.53,0.77,1.26,1.35,2.14,1.67c0.82,0.29,1.84,0.47,2.67,0.13c0.99-0.41,1.19-1.41,0.8-2.33
				c-0.44-1.03-1.4-1.49-2.33-2.02c-1.18-0.68-2.39-1.3-3.6-1.93c-2.05-1.05-4.27-2.4-5.66-4.29c-1.28-1.75-1.48-4.01-0.54-5.96
				c0.96-1.98,2.84-3.31,4.89-4c4.58-1.55,9.9-1.04,13.69,2.07c1.68,1.37,3.14,3.55,1.75,5.64c-0.98,1.47-3.29,2.93-5.09,2.1
				c-1.94-0.89-2.05-3.63-4.18-4.43c-1.52-0.58-3.42,0.53-3.16,2.27c0.18,1.24,1.69,1.84,2.64,2.41c1.24,0.75,2.51,1.42,3.79,2.09
				c2.29,1.22,4.65,2.46,5.66,5c0.91,2.29,0.55,5.07-1.12,6.92c-1.78,1.98-4.22,3.13-6.85,3.43
				C966.85,615.09,966.28,615.09,965.91,615.11z"
                />
                <path
                  d="M1063.41,586.6c1.2,0.1,2.41,0.11,3.57,0.43c1.2,0.33,2.33,0.92,3.38,1.58c1.66,1.03,3.76,2.75,3.62,4.91
				c-0.13,2.02-2.42,3.82-4.37,3.93c-2.37,0.14-2.82-2.48-4.22-3.8c-1.27-1.19-3.67-1.54-4.35,0.51c-0.38,1.14,0.43,2.01,1.32,2.58
				c1.02,0.66,2.09,1.25,3.15,1.84c2.08,1.16,4.48,2.04,6.16,3.78c1.43,1.48,2.08,3.44,1.89,5.48c-0.4,4.31-4.88,6.87-8.87,7.14
				c-4.32,0.29-9.63-1.57-12.23-5.17c-0.6-0.82-1.15-1.86-1.22-2.9c-0.07-1.03,0.56-2,1.26-2.7c1.22-1.21,3.53-1.91,5.08-0.92
				c0.94,0.59,1.36,1.74,1.94,2.64c0.5,0.77,1.19,1.37,2.03,1.74c0.89,0.38,2.16,0.67,3.07,0.21c0.86-0.43,0.97-1.42,0.65-2.24
				c-0.44-1.11-1.57-1.65-2.56-2.21c-1.12-0.64-2.27-1.19-3.42-1.79c-2.18-1.13-4.77-2.6-6.03-4.79c-1.1-1.92-1.01-4.33,0.19-6.18
				c1.31-2.03,3.62-3.21,5.95-3.66C1060.72,586.78,1062.05,586.61,1063.41,586.6z"
                />
                <path
                  d="M978.53,597.8c0-2.35-0.03-4.69,0.03-7.04c0.04-1.64,0.25-3.49,2.25-3.71c2.14-0.24,4.38-0.03,6.53-0.13
				c2.27-0.1,4.67-0.47,6.94-0.26c0.78,0.07,1.66,0.29,2.19,0.91c0.59,0.69,0.7,1.84,0.7,2.71c0,0.83-0.15,1.76-0.73,2.41
				c-0.61,0.69-1.43,0.73-2.3,0.7c-2.21-0.06-4.57-0.43-6.75,0.05c-0.9,0.19-1.26,0.67-1.34,1.59c-0.05,0.51-0.02,1.03-0.03,1.55
				c0,0.47-0.14,1.18,0.06,1.6c0.35,0.74,1.57,0.6,2.24,0.62c1.18,0.04,2.36,0.05,3.54,0.12c0.77,0.05,1.41,0.24,1.61,1.07
				c0.21,0.9,0.25,2.16,0.16,3.07c-0.21,2.07-3.13,1.43-4.55,1.41c-0.64-0.01-2.06-0.31-2.61,0.11c-0.58,0.44-0.3,2-0.29,2.65
				c0.01,0.58-0.04,1.27,0.6,1.51c0.37,0.14,0.9,0.05,1.3,0.05c0.62,0,1.23,0,1.85-0.01c1.13-0.01,2.25-0.05,3.38-0.08
				c1.02-0.03,2.39-0.19,3.32,0.35c0.86,0.5,0.7,1.5,0.67,2.35c-0.03,0.85,0.14,2.07-0.32,2.82c-0.38,0.62-1.1,0.68-1.77,0.72
				c-1.15,0.07-2.3,0.09-3.45,0.11c-2.52,0.05-5.04,0.17-7.56,0.06c-1.8-0.08-5.13,0.23-5.35-2.25c-0.22-2.48-0.16-5.04-0.19-7.53
				c-0.04-2.51-0.06-5.01-0.06-7.52C978.57,597.8,978.55,597.8,978.53,597.8z"
                />
              </g>
            </g>
            <g className="texts">
              <path
                d="M939.72,686.57c-0.12,0.2-0.26,0.39-0.38,0.58c-0.56,0.9-1.52,1.17-2.39,1.04c-3.5-0.54-2.76-8.42-2.15-10.7
			c0.06-0.28,0.28-0.47,0.6-0.44c0.39,0.05,0.77,0.04,1.16,0.08c0.52,0.05,0.74,0.27,0.72,0.79c-0.04,0.84-0.2,2.31-0.27,3.14
			c-0.08,1.09-0.17,2.16-0.02,3.24c0.02,0.21,0.12,0.44,0.23,0.64c0.24,0.44,0.72,0.42,0.93-0.03c0.16-0.38,0.29-0.75,0.34-1.16
			c0.14-0.95,0.22-1.92,0.31-2.89c0.04-0.41,0.06-0.83,0.07-1.25c0-0.56,0.34-0.74,0.73-0.77c0.39-0.04,0.79-0.01,1.18,0.02
			c0.38,0.02,0.56,0.21,0.58,0.62c0.03,0.72,0.03,1.46,0.06,2.21c0.01,0.77,0,1.53,0.06,2.28c0.22,2.22,1.81,1.52,2.05-0.27
			c0.27-1.86,0.13-3.78,0.1-5.61c-0.06-0.47,0.17-0.81,0.65-0.84c0.39-0.02,0.8-0.01,1.19,0.02c0.38,0.02,0.64,0.29,0.7,0.67
			c0.34,1.93,0.53,5.54-0.3,8.03c-1.07,3.15-4.64,3.1-5.87,0.19C939.88,686.32,939.81,686.46,939.72,686.57z"
              />
              <path
                d="M952.66,686.81c-0.12,0.2-0.26,0.39-0.38,0.58c-0.56,0.9-1.52,1.17-2.39,1.04c-3.5-0.54-2.76-8.42-2.14-10.7
			c0.06-0.28,0.28-0.47,0.6-0.44c0.39,0.05,0.77,0.04,1.16,0.08c0.52,0.05,0.74,0.27,0.71,0.79c-0.04,0.84-0.2,2.31-0.27,3.14
			c-0.08,1.09-0.17,2.16-0.02,3.24c0.02,0.21,0.12,0.44,0.23,0.64c0.25,0.44,0.72,0.42,0.93-0.03c0.16-0.38,0.29-0.75,0.34-1.16
			c0.14-0.95,0.22-1.92,0.31-2.89c0.04-0.41,0.06-0.83,0.07-1.25c0-0.56,0.34-0.74,0.73-0.77c0.39-0.04,0.79-0.01,1.18,0.02
			c0.38,0.02,0.56,0.21,0.58,0.62c0.03,0.72,0.03,1.46,0.06,2.21c0.01,0.77,0,1.53,0.06,2.28c0.23,2.22,1.81,1.52,2.06-0.27
			c0.27-1.86,0.13-3.78,0.1-5.61c-0.06-0.47,0.17-0.81,0.65-0.84c0.39-0.02,0.8-0.01,1.19,0.02c0.38,0.02,0.64,0.29,0.7,0.67
			c0.34,1.93,0.53,5.54-0.3,8.03c-1.07,3.15-4.64,3.1-5.87,0.19C952.82,686.57,952.74,686.71,952.66,686.81z"
              />
              <path
                d="M965.59,687.06c-0.12,0.2-0.26,0.39-0.38,0.58c-0.56,0.9-1.52,1.17-2.39,1.04c-3.5-0.54-2.76-8.42-2.15-10.7
			c0.06-0.28,0.28-0.47,0.6-0.44c0.39,0.05,0.77,0.04,1.16,0.08c0.52,0.05,0.74,0.27,0.71,0.79c-0.04,0.84-0.2,2.31-0.27,3.14
			c-0.08,1.09-0.17,2.16-0.02,3.24c0.02,0.21,0.12,0.44,0.23,0.64c0.25,0.44,0.72,0.42,0.93-0.03c0.16-0.38,0.29-0.75,0.34-1.16
			c0.14-0.95,0.22-1.92,0.31-2.89c0.04-0.41,0.06-0.83,0.07-1.25c0-0.56,0.34-0.74,0.73-0.77c0.39-0.04,0.79-0.01,1.18,0.02
			c0.38,0.02,0.56,0.21,0.58,0.62c0.03,0.72,0.03,1.46,0.06,2.21c0.01,0.77,0,1.53,0.06,2.28c0.23,2.22,1.81,1.52,2.06-0.27
			c0.27-1.86,0.13-3.78,0.1-5.61c-0.06-0.47,0.17-0.81,0.65-0.84c0.39-0.02,0.8-0.01,1.19,0.02c0.38,0.02,0.64,0.29,0.7,0.67
			c0.34,1.93,0.53,5.54-0.3,8.03c-1.07,3.15-4.63,3.1-5.87,0.19C965.75,686.81,965.68,686.95,965.59,687.06z"
              />
              <path
                d="M974.52,686.13c0.72,0.01,1.31,0.6,1.28,1.32c-0.03,0.73-0.54,1.25-1.33,1.28c-0.67,0.04-1.28-0.59-1.28-1.29
			C973.18,686.71,973.8,686.11,974.52,686.13z"
              />
              <path
                d="M981.79,681.6c-0.12-0.3-0.27-0.58-0.43-0.85c-0.08-0.13-0.22-0.27-0.36-0.37c-0.24-0.2-0.52-0.22-0.77-0.06
			c-0.51,0.3-0.5,1.03-0.11,1.38c0.36,0.3,0.75,0.59,1.14,0.86c0.46,0.35,0.98,0.64,1.41,0.98c0.83,0.66,1.18,1.54,1.13,2.58
			c-0.04,0.76-0.31,1.43-0.84,1.95c-0.92,0.9-2,1.16-3.23,0.87c-0.96-0.23-1.74-0.75-2.4-1.48c-0.38-0.43-0.61-0.94-0.73-1.52
			c-0.05-0.3,0.01-0.58,0.16-0.84c0.25-0.44,0.59-0.77,1.11-0.88c0.44-0.09,0.86,0.09,1.06,0.47c0.15,0.24,0.24,0.5,0.35,0.75
			c0.39,0.91,1.76,1.27,1.89,0.34c0.05-0.34-0.14-0.76-0.49-1.03c-0.42-0.3-0.84-0.63-1.29-0.9c-0.72-0.43-1.32-0.96-1.84-1.62
			c-1.04-1.58-0.24-3.7,1.61-4.21c1.03-0.28,2.03-0.3,2.81,0.04c1.14,0.51,2.83,2.02,1.72,3.43
			C983.14,682.19,982.18,682.51,981.79,681.6z"
              />
              <path
                d="M989.45,681.58c-0.02,1.63-0.02,3.38-0.01,5.01c0,0.52,0.04,1.03,0.03,1.54c0,0.24-0.09,0.49-0.17,0.73
			c-0.09,0.24-0.32,0.34-0.57,0.34c-0.35-0.01-0.69,0-1.02-0.02c-0.11,0-0.22-0.02-0.34-0.05c-0.49-0.16-0.58-0.29-0.56-0.8
			c0.04-1.57,0.1-3.14,0.13-4.72c0.03-0.79,0-1.73,0-2.53c0-0.13-0.02-0.27-0.02-0.38c-0.45-0.01-0.84-0.02-1.24-0.01
			c-0.88-0.02-0.98-0.13-0.99-0.97c-0.01-0.28,0-0.56,0-0.83c0.01-0.41,0.12-0.59,0.52-0.69c0.24-0.05,0.49-0.1,0.75-0.11
			c0.9-0.03,1.79-0.05,2.67-0.05c0.73,0.01,1.47,0.04,2.19,0.07c0.13,0,0.24,0.05,0.36,0.08c0.29,0.09,0.46,0.29,0.47,0.58
			c0.02,0.42,0.01,0.87-0.01,1.3c-0.02,0.42-0.19,0.56-0.59,0.58c-0.53,0.02-1.04,0.05-1.6,0.07
			C989.44,681.03,989.44,681.31,989.45,681.58z"
              />
              <path
                d="M994.1,687.55c-0.05,0.31-0.1,0.6-0.12,0.91c-0.04,0.5-0.36,0.74-0.8,0.8c-0.42,0.03-0.87,0.03-1.28-0.02
			c-0.41-0.04-0.61-0.36-0.6-0.77c0.02-2.68,0.18-6.86,1.89-8.88c0.65-0.76,1.51-1.33,2.45-1.37c2.54-0.14,3.55,3.2,3.75,5.05
			c0.18,1.69,0.11,3.37,0,5.05c-0.05,0.43-0.13,0.91-0.59,0.97c-0.45,0.02-0.91,0.04-1.39,0.03c-0.49-0.02-0.64-0.21-0.66-0.77
			c-0.02-0.39-0.06-0.73-0.09-1.08C995.8,687.51,994.96,687.53,994.1,687.55z M996.48,683.39c-0.16-1.42-0.64-2.09-1.03-2
			c-0.75,0.18-1.34,2.67-1.33,3.74c0.86-0.03,1.63-0.05,2.43-0.08C996.55,684.6,996.54,684,996.48,683.39z"
              />
              <path
                d="M1002.12,685.42c-1.95-0.74-1.69-4.05-1.72-5.59c-0.01-0.38,0.01-0.74,0.06-1.12c0.03-0.32,0.2-0.43,0.51-0.44
			c0.18,0,0.37,0.02,0.53,0.02c0.32,0.01,0.63,0.04,0.94,0.02c0.44-0.01,0.64,0.14,0.71,0.58c0.04,0.25,0.03,0.52,0.03,0.79
			c0,0.56-0.04,1.42-0.02,1.99c0.08,2.32,1.86,1.82,1.9-0.22c0-0.62-0.02-1.91-0.05-2.53c-0.01-0.38,0.22-0.49,0.46-0.51
			c0.42-0.04,1.01-0.07,1.45,0c0.77,0.04,0.81,0.87,0.8,1.47c-0.03,1.61-0.07,3.51-0.12,5.14c-0.04,0.76-0.21,1.51-0.56,2.22
			c-0.56,1.2-1.51,1.94-2.83,2.17c-0.66,0.11-1.29,0.1-1.95-0.04c-0.53-0.12-0.77-0.34-0.83-0.89c-0.06-0.38-0.05-0.8-0.02-1.21
			c0.02-0.36,0.22-0.58,0.62-0.63c0.24-0.02,0.48,0,0.72,0c0.43-0.01,0.87,0.03,1.31-0.02c0.48-0.08,0.79-0.41,0.9-0.92
			C1003.95,685.81,1003.02,685.75,1002.12,685.42z"
              />
              <path
                d="M1008.59,682.13c0.31-1.41,1.45-3.08,3-3.51c1.65-0.46,3.46,0.6,3.93,2.05c0.16,0.52,0.09,1-0.33,1.37
			c-0.4,0.33-0.83,0.38-1.34,0.24c-0.24-0.06-0.42-0.23-0.48-0.47c-0.03-0.11-0.05-0.23-0.11-0.35c-0.19-0.51-0.68-0.7-1.17-0.44
			c-0.13,0.1-0.27,0.21-0.34,0.33c-0.16,0.18-0.3,0.39-0.39,0.61c-0.4,1.05-0.57,2.15-0.29,3.25c0.44,2.23,1.69,2.52,2.88,0.49
			c0.19-0.3,0.4-0.43,0.76-0.32c0.27,0.06,0.53,0.17,0.79,0.28c0.6,0.22,0.46,0.84,0.33,1.28c-0.45,1.48-1.78,2.83-3.6,2.69
			C1008.14,689.35,1007.96,685.05,1008.59,682.13z"
              />
              <path
                d="M1022.66,683.64c0.14-1.46,0.17-2.83,0.28-4.22c0.05-0.94,1.54-0.81,2.25-0.67c0.57,0.11,0.49,0.87,0.44,1.23
			c-0.13,2.64-0.22,5.64-0.14,8.11c0.07,1.43,0.1,1.63-1.55,1.73c-1.22,0.05-1.51-0.52-1.48-1.74c0-0.59,0.01-1.59,0.03-2.2
			c-1.02-0.08-2.01,0-3.05-0.08c-0.02,0.21-0.04,0.41-0.04,0.57c-0.03,0.73-0.05,1.71-0.06,2.4c-0.01,0.53-0.33,0.93-0.83,0.95
			c-0.41,0.01-0.79,0.01-1.15-0.05c-0.59-0.08-0.81-0.37-0.8-0.81c0.06-3.37,0.25-6.72,0.26-9.22c-0.07-0.61,0.24-0.95,0.96-0.98
			c0.38-0.02,0.77-0.01,1.19,0.01c0.6,0.04,0.81,0.21,0.8,0.77c-0.02,1.28-0.06,2.55-0.09,3.84c0,0.08,0,0.15,0,0.25
			C1020.13,683.64,1022.05,683.71,1022.66,683.64z"
              />
              <path
                d="M1029.18,689.31c-0.05,0.31-0.22,0.5-0.53,0.54c-0.34,0.04-1.07,0.06-1.39,0.03c-0.66-0.05-0.93-0.4-0.92-1.06
			c0.01-0.35,0.01-0.69,0.02-1.05c0.07-2.46,0.11-5.42,0.27-7.87c0-0.17,0.01-0.35,0.02-0.53c0.02-0.34,0.21-0.54,0.54-0.54
			c0.45-0.01,1.29,0.01,1.73,0.06c0.36,0.04,0.49,0.21,0.49,0.58c0.02,0.3-0.01,0.59-0.02,0.9c-0.09,4.96-0.13,6.88-0.17,8.25
			C1029.24,688.85,1029.22,689.09,1029.18,689.31z"
              />
              <path
                d="M1033.92,687.18c0.51,0.01,1,0.02,1.5,0.04c0.32,0.01,0.49,0.21,0.55,0.52c0.12,0.54,0.11,1.08-0.03,1.61
			c-0.08,0.36-0.33,0.53-0.68,0.58c-0.17,0.01-0.34,0.02-0.49,0.03c-1.17,0.02-2.35,0.12-3.5-0.02c-0.49-0.07-0.85-0.42-0.91-0.93
			c-0.05-0.34-0.07-0.67-0.09-1.01c0.01-2.71,0.02-5.64,0.04-8.35c0.01-0.34,0.11-0.71,0.48-0.74c0.69-0.04,1.43-0.03,2.13,0.03
			c0.25,0.03,0.4,0.25,0.41,0.5c0.02,0.37,0.04,0.75,0.04,1.14c0.04,1.87,0.02,3.97,0.03,5.84c0.01,0.25-0.01,0.5-0.01,0.79
			C1033.59,687.19,1033.75,687.18,1033.92,687.18z"
              />
              <path
                d="M1040.63,687.3c0.51,0.01,1,0.02,1.5,0.04c0.32,0.01,0.49,0.21,0.55,0.52c0.12,0.54,0.11,1.08-0.03,1.61
			c-0.08,0.36-0.33,0.53-0.68,0.58c-0.17,0.01-0.34,0.02-0.49,0.03c-1.17,0.02-2.35,0.12-3.5-0.02c-0.49-0.07-0.85-0.42-0.91-0.93
			c-0.05-0.34-0.07-0.68-0.09-1.01c0.01-2.71,0.02-5.64,0.04-8.35c0.01-0.34,0.11-0.71,0.48-0.74c0.69-0.04,1.43-0.03,2.13,0.03
			c0.25,0.03,0.4,0.25,0.41,0.5c0.02,0.37,0.04,0.75,0.04,1.14c0.04,1.87,0.02,3.97,0.03,5.84c0.01,0.25-0.01,0.5-0.01,0.79
			C1040.31,687.31,1040.46,687.3,1040.63,687.3z"
              />
              <path
                d="M1045.04,687.44c0.72,0.01,1.31,0.6,1.28,1.32c-0.03,0.73-0.54,1.25-1.33,1.28c-0.67,0.04-1.28-0.58-1.28-1.29
			C1043.71,688.02,1044.32,687.43,1045.04,687.44z"
              />
              <path
                d="M1047.43,682.85c0.31-1.41,1.45-3.08,3-3.51c1.65-0.46,3.46,0.6,3.93,2.05c0.16,0.52,0.09,1-0.33,1.37
			c-0.4,0.33-0.84,0.38-1.34,0.24c-0.24-0.06-0.42-0.23-0.48-0.47c-0.03-0.11-0.05-0.23-0.11-0.35c-0.19-0.51-0.67-0.7-1.17-0.44
			c-0.13,0.1-0.27,0.21-0.34,0.33c-0.16,0.18-0.3,0.39-0.39,0.61c-0.4,1.05-0.57,2.15-0.29,3.25c0.44,2.23,1.7,2.52,2.88,0.49
			c0.19-0.3,0.4-0.43,0.76-0.32c0.27,0.06,0.53,0.17,0.79,0.28c0.6,0.22,0.46,0.84,0.33,1.28c-0.45,1.48-1.78,2.83-3.6,2.69
			C1046.98,690.08,1046.8,685.78,1047.43,682.85z"
              />
              <path
                d="M1062.74,688.6c-0.33,0.53-0.73,0.96-1.22,1.3c-1.46,1-3.19,0.82-4.47-0.44c-0.79-0.79-1.26-1.76-1.48-2.85
			c-0.33-1.65-0.16-3.25,0.57-4.75c0.39-0.7,0.87-1.32,1.49-1.8c1.48-1.07,3.25-0.92,4.55,0.39c0.8,0.79,1.26,1.78,1.48,2.88
			c0.1,0.51,0.15,1.01,0.17,1.3C1063.81,686.22,1063.48,687.48,1062.74,688.6z M1058.42,686.74c0.15,0.32,0.33,0.61,0.55,0.85
			c0.44,0.46,1.02,0.47,1.46,0.06c0.17-0.15,0.34-0.32,0.45-0.51c0.73-1.35,0.77-2.71,0.09-4.1c-0.11-0.25-0.31-0.48-0.54-0.68
			c-0.36-0.3-0.79-0.31-1.21-0.07c-0.27,0.21-0.47,0.46-0.63,0.73c-0.33,0.61-0.49,1.3-0.47,2.06
			C1058.08,685.62,1058.18,686.21,1058.42,686.74z"
              />
              <path
                d="M1071.01,687.45c-0.03,0.06-0.09,0.1-0.1,0.15c-0.2,0.43-0.55,0.65-1.04,0.61c-0.29-0.03-0.59-0.01-0.88-0.02
			c-0.32-0.02-0.51-0.21-0.65-0.46c-0.28-0.54-0.43-1.1-0.7-1.58c-0.14-0.25-0.26-0.36-0.27,0.15c-0.02,0.87-0.04,2.23-0.06,3.12
			c0,0.04,0,0.08,0,0.14c-0.02,0.83-0.24,1.06-1.06,1.09c-0.37,0.01-0.73-0.03-1.08-0.08c-0.43-0.08-0.68-0.41-0.67-0.88
			c0.02-0.58,0.1-1.68,0.11-2.27c0.04-2.41,0.07-4.65,0.12-7.07c0-0.03,0-0.07,0-0.1c0.03-0.56,0.2-0.74,0.73-0.76
			c0.39-0.01,0.8,0.04,1.21,0.08c0.29,0.03,0.5,0.22,0.64,0.48c0.65,1.12,1.28,2.21,1.89,3.35c0.04,0.07,0.1,0.14,0.15,0.21
			c0.22,0.31,0.35,0.32,0.58,0.01c0.07-0.1,0.16-0.19,0.22-0.3c0.45-0.85,0.89-1.58,1.34-2.43c0.14-0.26,0.28-0.51,0.42-0.77
			c0.16-0.33,0.5-0.44,0.81-0.46c0.35-0.04,0.73-0.03,1.1,0.01c0.5,0.05,0.79,0.37,0.85,0.86c0.02,0.21,0.05,0.44,0.03,0.65
			c-0.05,1.67-0.1,3.23-0.13,4.93c-0.02,1.16-0.02,2.75-0.03,3.92c0,0.55-0.11,0.69-0.67,0.73c-0.37,0.04-0.72,0.04-1.1,0.04
			c-0.59-0.02-0.78-0.25-0.8-0.86c-0.01-1.07-0.04-2.58-0.06-3.67c0-0.04-0.01-0.1-0.01-0.14c-0.03,0-0.04-0.01-0.07-0.01
			C1071.55,686.55,1071.27,686.99,1071.01,687.45z"
              />
              <path
                d="M1076.92,688.04c0.72,0.01,1.31,0.6,1.28,1.32c-0.03,0.73-0.54,1.25-1.33,1.28c-0.67,0.04-1.28-0.59-1.28-1.29
			C1075.58,688.62,1076.2,688.02,1076.92,688.04z"
              />
              <path
                d="M1081.84,689.18c-0.05,0.31-0.1,0.6-0.12,0.91c-0.04,0.5-0.36,0.74-0.8,0.8c-0.42,0.03-0.87,0.03-1.28-0.02
			c-0.41-0.04-0.61-0.36-0.6-0.77c0.02-2.68,0.18-6.86,1.89-8.88c0.65-0.76,1.51-1.33,2.45-1.37c2.54-0.14,3.55,3.2,3.75,5.05
			c0.18,1.69,0.11,3.37,0,5.05c-0.05,0.43-0.13,0.91-0.59,0.97c-0.45,0.02-0.91,0.04-1.39,0.03c-0.49-0.02-0.64-0.21-0.66-0.77
			c-0.02-0.39-0.06-0.73-0.09-1.08C1083.54,689.14,1082.7,689.17,1081.84,689.18z M1084.22,685.03c-0.16-1.42-0.64-2.09-1.03-2
			c-0.75,0.18-1.34,2.67-1.33,3.74c0.86-0.03,1.63-0.05,2.43-0.08C1084.29,686.24,1084.28,685.63,1084.22,685.03z"
              />
              <path
                d="M1092.86,687.79c0.36,0.26,0.75,0.49,1.15,0.72c0.22,0.13,0.45,0.21,0.67,0.31c0.43,0.2,0.51,0.38,0.48,0.85
			c-0.02,0.37-0.14,0.7-0.37,1c-0.24,0.32-0.56,0.47-0.99,0.4c-0.6-0.07-1.17-0.32-1.62-0.73c-0.41-0.4-0.8-0.84-1.18-1.26
			c-0.12-0.14-0.22-0.3-0.4-0.41c0.01,0.34,0.04,0.69,0.04,1.04c0.01,0.27,0,0.55-0.03,0.81c-0.03,0.35-0.19,0.5-0.53,0.55
			c-0.41,0.04-0.8,0.06-1.21,0.02c-0.41-0.04-0.61-0.28-0.65-0.7c-0.04-0.35-0.06-0.7-0.05-1.06c-0.02-2.96,0-5.76,0.13-8.56
			c0-0.11,0.03-0.21,0.06-0.32c0.08-0.22,0.2-0.33,0.43-0.36c0.66-0.08,1.31-0.07,1.97,0.02c0.29,0.03,0.59,0.07,0.9,0.13
			c2.36,0.54,3.55,2.17,3.23,4.47c-0.21,1.37-1.03,2.48-2.41,2.69C1092.62,687.54,1092.71,687.7,1092.86,687.79z M1090.67,685.56
			c0.08,0.01,0.15,0.04,0.21,0.05c1.17-0.06,1.89-1.19,1.43-2.15c-0.21-0.52-1.01-0.9-1.58-0.76
			C1090.71,683.65,1090.69,684.6,1090.67,685.56z"
              />
            </g>
          </g>
        </Link>
        <Link to={linkCogolleros} onClick={handleClickCogolleros}>
          <g className="cogolleros">
            <path
              class="green"
              d="M763.64,460.58c-2.2,12.89-7.27,25.67-14.84,38.03c-9.65,15.74-23.36,30.78-40.38,44.46
		c-35.34,28.41-84.92,50.92-141.92,61.52c-84.89,15.79-163.93,1.01-208.92-33.9c-10.07-7.82-18.44-16.65-24.78-26.37
		c-5.51-8.45-9.5-17.58-11.75-27.31l-0.04-0.2l-0.68-3.25c-13.58-73.03,74.61-150.68,196.99-173.44
		c122.37-22.75,232.58,18,246.17,91.03C765.31,440.93,765.3,450.78,763.64,460.58z"
            />
            <path
              class="green"
              d="M769.68,542.87l-2.3,14.81l-0.02,0.12l-0.53,3.41l-0.02,0.15c-10.29,57.39-85.51,112.91-184.43,131.31
		C471,713.38,370.74,679.37,354.6,616.45c40.38,45.04,128.72,66.15,224.52,48.33c91.46-17,163.83-64.67,188.88-118.17
		C768.59,545.37,769.15,544.12,769.68,542.87z"
            />
            <path
              class="green"
              d="M769.69,542.86l-0.01,0.01c-0.53,1.25-1.09,2.5-1.68,3.74c-25.05,53.5-97.42,101.17-188.88,118.17
		c-95.8,17.82-184.14-3.29-224.52-48.33c-11.19-12.5-18.7-26.84-21.65-42.7l-11.9-56.74c2.25,9.73,6.24,18.86,11.75,27.31
		c6.34,9.72,14.71,18.55,24.78,26.37c44.99,34.91,124.03,49.69,208.92,33.9c57-10.6,106.58-33.11,141.92-61.52
		c17.02-13.68,30.73-28.72,40.38-44.46c7.57-12.36,12.64-25.14,14.84-38.03c1.66-9.8,1.67-19.65-0.15-29.43l11.84,56.46l0.03,0.14
		l0.75,3.6C779.3,508.52,776.87,525.95,769.69,542.86z"
            />
            <g className="texts">
              <g>
                <path
                  d="M400.62,493.04c-4.71-0.46-8.6-2-10.37-6.68c-1.83-4.82-0.85-10.63,0.81-15.38c3.05-8.73,14.2-17.3,23.37-11.24
				c1.67,1.11,3.34,2.97,3.24,5.11c-0.12,2.46-2.79,3.97-5.02,4.2c-0.83,0.08-2.05,0.09-2.75-0.46c-0.71-0.56-0.71-1.56-1.17-2.28
				c-1.36-2.14-3.74-1.21-5.28,0.19c-3.87,3.52-5.05,10.16-3.43,14.97c1.67,4.98,5.99,3.36,8.78,0.37c2.12-2.28,2.82-3.69,6.17-2.91
				c1.04,0.24,2.37,0.34,2.73,1.56c0.31,1.07-0.44,2.51-0.88,3.47c-1.18,2.58-3.1,4.63-5.38,6.3c-2.55,1.87-5.01,2.44-8.12,2.78
				C403.79,493.12,400.62,493.07,400.62,493.04z"
                />
                <path
                  d="M476.89,476.85c-1.66,0.15-3.33,0.35-5,0.42c-1.61,0.07-2.56,0-2.75-1.72c-0.14-1.21-0.32-3.59,0.49-4.59
				c1.02-1.26,3.51-1.14,4.98-1.25c1.91-0.15,3.83-0.29,5.74-0.42c1.72-0.12,3.63-0.52,5.34-0.28c3.4,0.46,2.66,4.75,2.08,7.17
				c-1.61,6.79-6.48,11.22-13.38,12.39c-6.33,1.07-13.16-1.27-16.37-7c-6.7-12,1.31-26.46,14.65-28.33
				c5.93-0.83,13.3,1.29,15.08,7.65c0.96,3.42-0.5,4.78-3.89,5.32c-1.21,0.19-3.02,0.43-4.13-0.18c-1.26-0.69-1.26-2.44-2.16-3.46
				c-1.97-2.23-5.74-1.44-7.92,0.01c-2.93,1.95-4.24,5.94-4.14,9.3c0.08,2.87,1.3,6.64,4.16,7.89c2.48,1.09,5.42,0.37,6.87-1.97
				C476.69,477.56,476.74,477.27,476.89,476.85z"
                />
                <path
                  d="M620.69,466.76c1.84,0.89,3.63,1.75,5.56,2.44c1.44,0.51,3.14,0.8,4.51,1.48c2.2,1.1,1.95,4.37,0.45,6.02
				c-1.97,2.18-6,1.2-8.32,0.22c-3.22-1.37-5.84-4.01-8.8-5.85c0.38,2.08,2.2,6.71-0.17,7.82c-2.29,1.07-7.1,1.68-8.04-1.29
				c-1.14-3.59-1.38-7.66-1.93-11.37c-0.54-3.64-1.08-7.28-1.56-10.93c-0.23-1.79-0.42-3.58-0.6-5.37c-0.13-1.24-0.75-3.23,0.1-4.31
				c0.86-1.08,3.06-0.99,4.28-1.1c1.85-0.17,3.71-0.22,5.57-0.13c6.14,0.3,13.1,2.14,15.71,8.31c1.15,2.72,1.19,6.18-0.07,8.88
				c-1.28,2.75-3.83,4.06-6.62,4.93C620.73,466.59,620.71,466.68,620.69,466.76z M613.01,452.05c-0.38,0-0.77-0.07-1.12,0.03
				c-1.01,0.27,0.44,6.79,0.61,7.73c0.22,1.25,0.3,1.6,1.64,1.38c1-0.16,2-0.55,2.81-1.17C621.18,456.79,617.38,451.9,613.01,452.05
				z"
                />
                <path
                  d="M665.51,462.96c-0.15,6.31-5.24,12.51-11.56,13.59c-5.79,0.99-12.27-1.86-16.03-6.2c-4.21-4.86-6.39-12.28-4.49-18.49
				c1.9-6.23,7.48-10.77,14.18-10.47c7.33,0.32,13.5,5.62,16.26,12.11C665.2,456.65,665.5,458.15,665.51,462.96z M643.02,456.97
				c0.09,0.74,0.18,1.66,0.33,2.56c0.59,3.49,3.24,8,7.1,8.67c4.77,0.82,6.2-5.34,5.9-8.81c-0.31-3.64-2.95-8.29-6.66-9.46
				C645.11,448.49,643.3,453.43,643.02,456.97z"
                />
                <path
                  d="M505.9,486.43c-14.38-0.78-18.23-19.14-10.34-29.07c3.71-4.67,9.78-7.55,15.77-6.17c6.05,1.4,10.11,6.41,11.4,12.28
				c1.53,6.93-0.98,14.47-6.36,19.16C513.55,485.09,510.13,486.34,505.9,486.43z M501.5,468.89c0,2.99,0.93,5.59,3.16,7.69
				c3.01,2.84,6.72,0.22,8.25-2.76c1.57-3.06,1.88-6.95,0.44-10.11c-1.34-2.94-4.4-5.87-7.75-3.84
				C502.59,461.72,501.5,465.61,501.5,468.89z"
                />
                <path
                  d="M420.59,476.12c0.18-6.25,2.8-12.06,7.53-16.23c4.54-4,11.59-5.87,17.14-2.75c5.7,3.2,7.85,10.46,6.79,16.54
				c-1.03,5.94-4.21,11.5-9.38,14.81c-6.48,4.14-14.98,3.58-19.5-3.09C421.29,482.62,420.53,479.47,420.59,476.12z M443.4,472.45
				c0.02-2.37-0.52-4.24-1.54-5.96c-2.21-3.75-6.21-2.67-8.59,0.27c-2.22,2.75-3.13,6.92-2.43,10.37c0.65,3.21,3.61,6.8,7.17,5.02
				C441.41,480.45,443.36,476.08,443.4,472.45z"
                />
                <path
                  d="M697,465c0,2-1.95,6.39-3.08,7.16c-2.27,1.54-4.91,2.14-7.63,2.11c-5.43-0.06-11.71-2.2-15.14-6.58
				c-1.74-2.22-2.47-4.78-0.13-6.92c1.74-1.6,4.41-1.67,6.28-0.28c2.2,1.64,3,4.15,5.96,4.82c2.14,0.48,4.96-0.19,3.59-2.9
				c-1.2-2.38-4.82-3.19-7.1-4.11c-2.8-1.13-5.6-2.29-8.05-4.08c-4.19-3.05-6.24-9.33-1.11-12.73c5.06-3.35,11.75-3.23,17.14-0.87
				c2.35,1.03,5.96,3.19,6.27,6.03c0.25,2.32-2.75,5.2-5.09,4.93c-3.22-0.38-4.29-4.7-7.42-5.33c-3.53-0.72-4.24,3.25-1.48,4.81
				c3.21,1.81,6.89,2.91,10.23,4.47C692.5,456.6,698,460,697,465z"
                />
                <path
                  d="M585.03,481.17c-1.92-0.16-4.79,0.25-5.7-1.87c-0.45-1.06-0.42-2.54-0.57-3.66c-0.21-1.57-0.41-3.13-0.6-4.7
				c-0.71-5.84-1.33-11.69-1.9-17.54c-0.17-1.75-0.97-4.39,0.15-5.96c1.17-1.65,3.98-1.34,5.73-1.51c2.81-0.27,5.61-0.59,8.41-0.88
				c2.1-0.22,5.2-1.07,6.82,0.77c1.14,1.3,1.64,4.28,0.69,5.78c-1.18,1.86-4.75,1.28-6.59,1.36c-1.92,0.09-5.57-0.25-5.82,2.26
				c-0.18,1.79-0.19,4.53,1.88,4.84c2.08,0.31,4.94-0.96,6.93-0.03c1.42,0.66,2.15,4.49,1.45,5.8c-0.95,1.76-4.63,1.01-6.23,1.14
				c-0.68,0.05-2.1-0.04-2.47,0.63c-0.31,0.56,0.18,3.52,0.39,4.04c0.78,2.02,5.37,0.77,7.24,0.62c1.96-0.16,5.55-1.32,6.69,0.91
				c0.73,1.41,1.37,5.61-0.32,6.48c-1.15,0.58-2.98,0.45-4.25,0.57c-1.92,0.19-3.84,0.38-5.77,0.53
				C589.28,480.9,587.38,481.01,585.03,481.17z"
                />
                <path
                  d="M564.77,473.08c1.51-0.09,3.03-0.18,4.54-0.27c1.19-0.07,3.29-0.57,4.41-0.06c2.08,0.95,2.48,6.2,1.13,7.76
				c-0.83,0.97-2.58,1.04-3.75,1.19c-1.9,0.24-3.84,0.33-5.75,0.48c-1.65,0.13-3.3,0.25-4.95,0.37c-1.59,0.12-3.47,0.5-4.96-0.27
				c-2.35-1.21-2.26-5.5-2.52-7.77c-0.4-3.46-0.64-6.95-0.92-10.43c-0.28-3.51-0.55-7.02-0.82-10.54c-0.09-1.23-0.64-3.25-0.12-4.41
				c0.61-1.35,2.32-1.19,3.57-1.29c2.34-0.2,6.77-1.62,7.42,1.45c0.85,3.99,1.02,8.24,1.48,12.28
				C563.96,465.37,564.35,469.18,564.77,473.08z"
                />
                <path
                  d="M538.8,474.87c1.76-0.12,3.51-0.25,5.27-0.36c1.19-0.08,3.2-0.54,4.24,0.25c1.67,1.27,1.87,6.48,0.19,7.79
				c-1.08,0.84-3.34,0.85-4.63,1.01c-1.97,0.25-3.95,0.42-5.93,0.59c-2.66,0.24-7.78,1.49-9.63-1.12c-0.88-1.24-0.82-3.24-0.98-4.68
				c-0.23-2-0.36-4-0.47-6.01c-0.22-3.9-0.41-7.81-0.6-11.71c-0.09-1.88-0.18-3.77-0.27-5.65c-0.06-1.2-0.48-3.3,0.18-4.4
				c0.7-1.16,2.38-0.95,3.56-1.04c1.8-0.14,4.02-0.6,5.81-0.32c1.46,0.23,1.43,1.26,1.57,2.57c0.23,2.15,0.42,4.31,0.61,6.47
				c0.4,4.7,0.75,9.41,1.09,14.12C538.85,473.16,538.8,473.95,538.8,474.87z"
                />
              </g>
            </g>
          </g>
        </Link>
        <Link to={linkFuegos} onClick={handleClickFuegos}>
          <g className="fuegos">
            <path
              class="green"
              d="M1349.13,197.43c0,0-0.05,0.78-0.14,2.28c-0.89,4.3-6.05,13.22-33.36,13.22c-14.57,0-46.17,0.16-78.63,0.36
		c-47.75,0.29-97.37,0.64-97.37,0.64s-7.12,0.05-13.09-2.94c-1.83-0.91-3.54-2.11-4.91-3.68c-1.23-1.4-2.17-3.11-2.67-5.17
		c-0.47-1.92-0.55-4.15-0.1-6.74c0.13-0.79,1.01-3.75,1.9-6.62l-0.13,4.15c0,0-0.33,0.86-0.44,2.2c-0.14,1.74,0.11,4.3,2,6.85h0.01
		c0.35,0.48,0.77,0.96,1.25,1.43c1.24,1.22,2.92,2.4,5.18,3.43c3.48,1.61,8.35,2.88,15.11,3.49l93.66-1.75l88.23-1.65c0,0,15,0,17-9
		l0.73-10.25C1348.81,191.72,1349.13,197.43,1349.13,197.43z"
            />
            <path
              class="green"
              d="M1348.99,199.71c-1.59,27.21-17.07,289.75-20.83,308.64c-3.96,19.92-23.52,18.99-23.52,18.99l-164.15-1
		c-23.64-0.09-24.24-14.41-24.24-14.41l3.96-301.35c2.16,0.23,4.63,0.35,6.33,0.41c5.97,2.99,13.09,2.94,13.09,2.94
		s49.62-0.35,97.37-0.64c32.46-0.2,64.06-0.36,78.63-0.36C1342.94,212.93,1348.1,204.01,1348.99,199.71z"
            />
            <path
              class="green"
              d="M1243.97,131.69l-2.04,23.83l-2.61,30.61l-1.92,22.45l-93.66,1.75c-6.76-0.61-11.63-1.88-15.11-3.49
		c-2.26-1.03-3.94-2.21-5.18-3.43c-0.48-0.47-0.9-0.95-1.25-1.43h-0.01c-1.89-2.55-2.14-5.11-2-6.85c0.11-1.34,0.44-2.2,0.44-2.2
		l0.13-4.15l1.71-54.8c0.49,0.95,1.19,1.98,2.16,3.07c7,7.88,28,3.88,42,1.88C1177.84,137.33,1214.07,132.52,1243.97,131.69z"
            />
            <path
              class="green"
              d="M1346.13,148.81l-2.77,38.87l-0.73,10.25c-2,9-17,9-17,9l-88.23,1.65l1.92-22.45l2.61-30.61
		C1287.36,155.91,1346.13,148.81,1346.13,148.81z"
            />
            <path
              class="green"
              d="M1356.63,135.93c-2,11-10.5,12.88-10.5,12.88s-58.77,7.1-104.2,6.71l2.04-23.83
		c7.44-0.2,14.49-0.16,20.66,0.24c29.79,1.92,91.48,12.28,92.45-2.06C1357.19,132.04,1356.97,134.09,1356.63,135.93z"
            />
            <path
              class="green"
              d="M1357.08,129.82c0.01,0.02,0.01,0.03,0,0.05c-0.97,14.34-62.66,3.98-92.45,2.06
		c-6.17-0.4-13.22-0.44-20.66-0.24l0.63-7.45c15.13-1.04,29.21-1.6,40.03-1.31c36.96,1,77.97,9.68,67.57-5.1
		c2.05,2.36,3.32,4.79,4.06,7.19c0,0.01,0.01,0.03,0.01,0.04c0.29,0.99,0.5,1.98,0.63,2.94c0.01,0.02,0.01,0.04,0.01,0.06
		C1357.07,128.69,1357.12,129.27,1357.08,129.82z"
            />
            <path
              class="green"
              d="M1284.63,122.93c-10.82-0.29-24.9,0.27-40.03,1.31l0.03-0.31l-5.84-23.35v-0.01l-0.16-0.64c0,0,12-2,65,2
		c28.44,2.15,42.2,8.62,48.53,15.85c0.01,0.02,0.02,0.03,0.04,0.05C1362.6,132.61,1321.59,123.93,1284.63,122.93z"
            />
            <path
              class="green"
              d="M1238.79,100.58L1238.79,100.58l-1.16-0.65c0,0-78,5-102,15c-9.62,4.01-13.61,8.66-13.34,12.53v0.01
		c0.03,0.52,0.14,1.02,0.34,1.51c0,0,0,0,0,0.01c1.91,4.95,11.38,8.12,25,5.94c17.69-2.83,60.39-8.16,96.97-10.69l0.03-0.31
		L1238.79,100.58z M1151.33,128.84c-8.95,1.36-16.74-0.44-18.21-4.03c-0.11-0.24-0.18-0.5-0.22-0.76
		c-0.62-4.1,6.63-8.59,16.18-10.04c9.56-1.44,17.81,0.7,18.43,4.8C1168.13,122.9,1160.88,127.39,1151.33,128.84z"
            />
            <path
              class="green"
              d="M1244.6,124.24l-0.63,7.45c-29.9,0.83-66.13,5.64-77.34,7.24c-14,2-35,6-42-1.88
		c-0.97-1.09-1.67-2.12-2.16-3.07c-1.45-2.8-1.02-4.99-0.18-6.51c0.03,0.52,0.14,1.02,0.34,1.51c0,0,0,0,0,0.01
		c1.91,4.95,11.38,8.12,25,5.94C1165.32,132.1,1208.02,126.77,1244.6,124.24z"
            />
            <path
              class="green"
              d="M1151.33,128.84c-8.95,1.36-16.74-0.44-18.21-4.03c-0.11-0.24-0.18-0.5-0.22-0.76
		c-0.62-4.1,6.63-8.59,16.18-10.04c9.56-1.44,17.81,0.7,18.43,4.8C1168.13,122.9,1160.88,127.39,1151.33,128.84z"
            />
            <path
              class="green"
              d="M1118.96,202.14c-2.27-0.07-4.02-0.66-4.33-2.21c-0.55-2.74,1.9-3.98,4.23-4.53
		C1118.41,197.99,1118.49,200.22,1118.96,202.14z"
            />
            <path
              class="green"
              d="M1126.54,210.99c-1.7-0.06-4.17-0.18-6.33-0.41c-1.44-0.16-2.74-0.37-3.58-0.65c-3-1-2-10-2-10
		c0.31,1.55,2.06,2.14,4.33,2.21c0.5,2.06,1.44,3.77,2.67,5.17C1123,208.88,1124.71,210.08,1126.54,210.99z"
            />
            <g className="texts">
              <g>
                <path
                  d="M1263.74,264.88c-0.58,1.69-0.66,3.52-1.28,5.23c-0.59,1.62-1.39,3.17-2.38,4.59c-2.02,2.91-4.86,5.7-8.2,7
				c-3.68,1.44-7.21,1.13-9.88-2.02c-2.17-2.57-2.17-6.37,0.95-8.05c3.06-1.65,6.92-2.38,7.79-6.37c0.92-4.24-3.92-4.93-6.52-2.78
				c-1.48,1.22-2.58,3.09-3.72,4.62c-1.28,1.74-2.48,3.54-3.87,5.2c-2.41,2.89-5.48,5.72-9.2,6.7c-6.91,1.83-13.9-2.74-15.86-9.39
				c-2.34-7.97-0.12-16.38,7-21.07c3.12-2.05,6.86-2.3,9.86,0.13c2.21,1.79,4.29,5.64,1.68,7.97c-2.28,2.04-7.77,2.2-8.24,6.04
				c-0.43,3.55,4.41,5.07,6.74,3.01c1.71-1.51,3.06-3.64,4.47-5.43c1.43-1.82,2.78-3.71,4.21-5.53c2.5-3.19,5.87-5.33,9.95-5.69
				c8.64-0.76,15.52,5.38,16.29,13.91C1263.62,262.67,1263.74,263.97,1263.74,264.88z"
                />
                <path
                  d="M1217.3,403c13.2,1.01,32.98,1.66,37.67,17.28c2.02,6.72,0.77,15-4.35,20.02c-5.28,5.18-13.26,6.53-20.35,6.82
				c-4.06,0.17-8.11-0.08-12.16-0.31c-3.89-0.22-8.18-0.02-11.94-1.12c-1.36-0.4-2.83-0.97-3.29-2.45c-0.58-1.88-0.4-4.38-0.16-6.3
				c0.18-1.41,0.38-3.31,1.48-4.35c1.23-1.16,3.2-0.79,4.74-0.73c4.07,0.17,8.12,0.64,12.17,0.94c3.98,0.29,8.31,1.01,12.28,0.45
				c3.17-0.45,6.76-2.23,7.74-5.55c0.89-3.04-0.74-5.97-3.22-7.65c-3.41-2.3-7.96-2.94-11.95-3.47c-4.45-0.59-8.96-0.78-13.44-0.85
				c-3.1-0.05-7.62,0.92-8.56-3.02c-0.67-2.79-0.38-8.96,3.48-9.2C1210.46,403.34,1213.49,403.2,1217.3,403z"
                />
                <path
                  d="M1243.04,342.6c0,2.21,0.12,4.45-0.05,6.65c-0.18,2.34-1.75,2.85-3.9,2.8c-1.62-0.04-4.34,0.28-5.76-0.6
				c-1.69-1.04-1.24-3.96-1.23-5.61c0-2.52,0.08-5.04,0.24-7.55c0.14-2.27,0.1-4.78,0.64-7c1.07-4.38,7.89-2.76,10.96-2.04
				c7.82,1.83,14.38,6.99,15.53,15.3c1.17,8.51-3.19,16.46-10.76,20.33c-15.09,7.7-40.11,2.75-41.89-17.23
				c-0.72-8.07,4.1-16.41,11.94-18.84c2-0.62,4.33-1,6.43-0.85c1.86,0.13,2.56,1.54,2.96,3.22c0.48,1.98,0.62,4.53-0.13,6.47
				c-0.75,1.94-2.91,2.06-4.59,2.73c-4.74,1.89-5.22,7.19-2.19,10.93c3,3.69,8.2,4.82,12.71,4.83c4.23,0.01,9.84-0.93,12.38-4.78
				c2.15-3.27,0.71-7.56-3.02-8.77C1243.26,342.57,1243.2,342.59,1243.04,342.6z"
                />
                <path
                  d="M1237.53,324.43c-8.37,0.02-17-2.23-23.04-8.37c-3.04-3.09-5.36-7.04-5.55-11.47c-0.2-4.53,1.76-8.83,4.94-11.97
				c6.84-6.74,17.31-8.56,26.47-6.82c8.57,1.63,18.2,6.73,20.69,15.82c2.74,9.98-4.96,18.3-13.91,21.23
				C1243.57,324.02,1239.91,324.38,1237.53,324.43z M1236.97,312c0.71-0.04,1.43-0.04,2.14-0.12c3.76-0.4,11.28-2.85,10.28-7.92
				c-0.84-4.27-6.34-6.38-10.03-7.23c-4.48-1.04-9.57-0.42-13.63,1.8c-3.96,2.15-5.09,6.34-1.48,9.47
				C1227.71,311,1232.52,311.97,1236.97,312z"
                />
                <path
                  d="M1205,385.61c0-1.86,0-3.72,0-5.58c0-1.82-0.28-3.91,0.33-5.66c1.23-3.55,5.69-3.52,8.78-2.78
				c1.24,0.3,2.57,0.81,3.18,2.02c0.74,1.47,0.2,3.57,0.09,5.14c-0.13,1.81-0.31,3.62-0.37,5.43c-0.04,1.25,0.07,3.05,1.24,3.82
				c1.16,0.77,3.11,0.56,4.43,0.64c1.08,0.07,3.19,0.66,4.01-0.33c0.8-0.97,0.55-3.08,0.64-4.25c0.12-1.54,0.04-3.64,0.73-5.05
				c0.62-1.27,1.9-1.16,3.12-1.14c1.62,0.02,3.67-0.16,5.22,0.37c2.99,1.01,1.39,5.83,1.22,8.1c-0.09,1.25-0.37,2.56,1.04,2.98
				c0.86,0.26,2.13,0.16,3.03,0.21c0.9,0.05,1.92,0.21,2.81,0.05c1.27-0.22,1.24-1.15,1.29-2.28c0.09-2.09,0.14-4.18,0.2-6.27
				c0.07-2.29-0.73-6.76,2.19-7.62c1.38-0.41,3.04-0.06,4.44,0.09c1.31,0.14,3.15,0.08,4.23,0.98c0.96,0.8,0.87,2.12,0.87,3.25
				c0,1.92-0.06,3.84-0.11,5.76c-0.1,3.73-0.08,7.5-0.56,11.2c-0.35,2.71-0.55,6.18-3.93,6.44c-3.75,0.29-7.7-0.23-11.46-0.37
				c-8.5-0.32-17-0.77-25.49-1.21c-2.06-0.11-4.14-0.18-6.18-0.48c-1.57-0.23-3.41-0.43-4.44-1.8c-1.04-1.4-0.72-3.31-0.66-4.94
				c0.09-2.24,0.16-4.47,0.16-6.71C1205.03,385.61,1205.01,385.61,1205,385.61z"
                />
                <path
                  d="M1201.18,463.63c0.16-3.14,0.16-6.33,0.57-9.45c0.36-2.73,0.84-4.99,3.98-4.97c2.21,0.01,6.19-0.4,7.88,1.36
				c1.72,1.79,0.85,5.5,0.77,7.71c-0.08,2.12-1.09,5.75,1.11,7.12c0.86,0.54,1.92,0.57,2.9,0.6c1.26,0.05,3.25,0.33,4.45-0.13
				c1.08-0.41,0.9-1.44,0.92-2.47c0.03-1.79,0.05-3.59,0.08-5.38c0.02-1.26-0.18-2.99,0.55-4.08c0.78-1.16,2.53-0.88,3.73-0.84
				c2.06,0.07,5.68-0.4,6.95,1.68c0.58,0.94,0.47,2.1,0.44,3.15c-0.07,1.73-0.21,3.48-0.19,5.21c0.02,1.94,0.32,2.1,2.22,2.24
				c1.61,0.12,3.24,0.09,4.86,0.13c2.81,0.06,6.49-0.37,9.08,0.96c2.46,1.26,1.68,4.6,1.54,6.84c-0.15,2.56-0.84,4.35-3.55,4.92
				c-3.14,0.66-6.58,0.22-9.76,0.18c-3.25-0.04-6.49-0.2-9.74-0.35c-7.28-0.34-14.61-0.63-21.87-1.32
				c-2.59-0.24-5.22-0.65-6.32-3.35c-1.18-2.9-0.52-6.7-0.52-9.76C1201.24,463.63,1201.21,463.63,1201.18,463.63z"
                />
              </g>
            </g>
          </g>
        </Link>
        <Link to={linkLlaveros} onClick={handleClickLlaveros}>
          <g className="llaveros">
            <path
              class="green"
              d="M425.9,737.7c-10.56,2.09-12.27,7.23-12.27,7.23s-25.45,68.96-31.85,83.52c-1.5-1.91-1.94-4.64-0.15-8.52
		c6-13,31-81,31-81s2.11-5.62,9.26-7.44c0.59,0.76,1.18,1.56,1.74,2.41C424.54,735.26,425.29,736.52,425.9,737.7z"
            />
            <path
              class="green"
              d="M425.9,737.7c-10.56,2.09-12.27,7.23-12.27,7.23s-25.45,68.96-31.85,83.52c-1.5-1.91-1.94-4.64-0.15-8.52
		c6-13,31-81,31-81s2.11-5.62,9.26-7.44c0.59,0.76,1.18,1.56,1.74,2.41C424.54,735.26,425.29,736.52,425.9,737.7z"
            />
            <path
              class="green"
              d="M744.63,763.93l-9,60c-0.11,0.76-0.23,1.51-0.34,2.23c0,0.01,0,0.02-0.01,0.03
		c-2.01,12.5-5.22,19.02-11.65,26.74c-4.17,5.01-16.71,6.53-20.74,6.9c-0.78,0.07-1.56,0.09-2.34,0.07l-309.72-9.97
		c-9.56-0.92-14.81-3.96-17.6-7.84c-3.27-4.56-3.14-10.3-2.6-15.16c0.61-5.47,12.67-37.53,22.03-61.84c1.24-3.22,2.44-6.3,3.55-9.17
		c2.24-5.77,4.15-10.67,5.47-14.05l0.01-0.01c0-0.01,0-0.01,0-0.01c0.68-1.71,1.2-3.03,1.53-3.87c1.67-1.71,3.2-3.44,4.59-5.19
		c0.01-0.02,0.01-0.03,0.02-0.04c2.3-2.9,4.2-5.83,5.64-8.77c1.75,0.98,3.49,2.28,5.17,3.9c-10.5,2.89-13.01,11.05-13.01,11.05
		l-3.83,10.33v0.01c0,0,0,0.01-0.01,0.01l-26.16,70.65c-0.81,2.28-1.17,4.28-1.21,6.05c-0.52,0.84-0.82,2.78,0.21,8.95
		c0.25,1.5,0.75,2.81,1.43,3.96c0.15,0.25,0.31,0.49,0.48,0.72c0.03,0.06,0.07,0.11,0.12,0.17c0.17,0.24,0.35,0.47,0.55,0.69
		c0,0.01,0.01,0.02,0.01,0.02c0.2,0.24,0.42,0.48,0.65,0.7c0.12,0.12,0.24,0.24,0.37,0.35c0.11,0.11,0.22,0.21,0.34,0.31
		c0.01,0.01,0.01,0.01,0.02,0.02c0.18,0.15,0.36,0.3,0.55,0.44c0.84,0.65,1.75,1.21,2.69,1.69c0.27,0.14,0.55,0.27,0.83,0.4
		c0.16,0.07,0.32,0.14,0.48,0.21c0.22,0.09,0.44,0.18,0.66,0.26c0.14,0.07,0.29,0.12,0.44,0.17c1.34,0.5,2.69,0.86,3.95,1.13
		c0.21,0.05,0.42,0.09,0.62,0.13c0.14,0.02,0.28,0.05,0.41,0.07c0.14,0.03,0.27,0.05,0.4,0.07c0.72,0.12,1.39,0.22,1.99,0.29
		c0.16,0.01,0.32,0.03,0.48,0.05c0.15,0.01,0.3,0.03,0.44,0.04c0.29,0.02,0.55,0.04,0.78,0.06c0.12,0,0.23,0.01,0.33,0.02
		c0.62,0.03,0.98,0.03,0.98,0.03l304,10c0,0,22,0,26-12c1.11-3.33,1.76-6.74,2.11-9.92c0.01-0.01,0.01-0.02,0.01-0.03
		c0.01-0.04,0.01-0.08,0.02-0.12l1.12-8.35l9.74-72.58c1.12-7.07-1.37-11.23-4.92-13.67C748.66,750.22,744.63,763.93,744.63,763.93z
		"
            />
            <path
              class="green"
              d="M732.63,752.93c-0.08,0.46-0.17,1-0.27,1.61c-1.55-4.76-6.43-6.92-9.93-7.88c-2.17-0.6-3.8-0.73-3.8-0.73
		s-257-8-279.5-9c-1.35-0.06-2.63-0.08-3.83-0.08c-0.37-1.84-0.92-3.76-1.71-5.68l289.04,9.76c0,0,0.51,0,1.3,0.11
		C726.98,741.44,734.22,743.4,732.63,752.93z"
            />
            <path
              class="green"
              d="M726.74,835.01c-0.35,3.18-1,6.59-2.11,9.92c-4,12-26,12-26,12l-304-10c0,0-0.36,0-0.98-0.03
		c-0.1-0.01-0.21-0.02-0.33-0.02c-0.23-0.02-0.49-0.04-0.78-0.06c-0.14-0.01-0.29-0.03-0.44-0.04c-0.16-0.02-0.32-0.04-0.48-0.05
		c-0.6-0.07-1.27-0.17-1.99-0.29c-0.13-0.02-0.26-0.04-0.4-0.07c-0.13-0.02-0.27-0.05-0.41-0.07c-0.2-0.04-0.41-0.08-0.62-0.13
		c-1.26-0.27-2.61-0.63-3.95-1.13c-0.15-0.05-0.3-0.1-0.44-0.17c-0.22-0.08-0.44-0.17-0.66-0.26c-0.16-0.07-0.32-0.14-0.48-0.21
		c-0.28-0.13-0.56-0.26-0.83-0.4c-0.94-0.48-1.85-1.04-2.69-1.69c-0.19-0.14-0.37-0.29-0.55-0.44c-0.01-0.01-0.01-0.01-0.02-0.02
		c-0.12-0.1-0.23-0.2-0.34-0.31c-0.13-0.11-0.25-0.23-0.37-0.35c-0.22-0.23-0.44-0.46-0.65-0.7c0,0-0.01-0.01-0.01-0.02
		c-0.19-0.22-0.38-0.45-0.55-0.69c-0.05-0.06-0.09-0.11-0.12-0.17c-0.17-0.23-0.33-0.47-0.48-0.72c-0.68-1.15-1.18-2.46-1.43-3.96
		c-1.03-6.17-0.73-8.11-0.21-8.95c-0.3,11.45,13.21,12.95,13.21,12.95l32.2,1.11h0.04l285.76,9.89
		c13.42-1.58,18.74-9.39,20.38-12.61C726.39,836.6,726.63,835.82,726.74,835.01z"
            />
            <path
              class="green"
              d="M735.28,826.19c-0.23,7.35-1.21,16.01-3.88,23.74c-6.23,18-33.77,18-33.77,18l-291-10c0,0-17-1-26.17-6.88
		c-3.83-2.45-6-5.84-7.23-8.96c2.79,3.88,8.04,6.92,17.6,7.84l309.72,9.97c0.78,0.02,1.56,0,2.34-0.07
		c4.03-0.37,16.57-1.89,20.74-6.9C730.06,845.21,733.27,838.69,735.28,826.19z"
            />
            <path
              class="green"
              d="M737.63,753.93l-9.74,72.58l-1.12,8.35c-0.01,0.04-0.01,0.08-0.02,0.12c0,0.01,0,0.02-0.01,0.03
		c-0.11,0.81-0.35,1.59-0.73,2.31c-1.64,3.22-6.96,11.03-20.38,12.61l-285.76-9.89h-0.04l-32.2-1.11c0,0-13.51-1.5-13.21-12.95
		c0.04-1.77,0.4-3.77,1.21-6.05l26.16-70.65c0.01,0,0.01-0.01,0.01-0.01v-0.01l3.83-10.33c0,0,2.51-8.16,13.01-11.05
		c1.12,1.07,2.2,2.27,3.25,3.61c-7.15,1.82-9.26,7.44-9.26,7.44s-25,68-31,81c-1.79,3.88-1.35,6.61,0.15,8.52v0.01
		c3.52,4.47,12.85,4.47,12.85,4.47l47.51,1.53l25.37,0.82l1.68,0.06h0.01l33.34,1.07h0.02l34.79,1.12l71.11,2.3l32.59,1.05
		l41.98,1.35h0.01l21.59,0.7c12-1,15-13,15-13s0.19-1.11,0.52-3.08c2.11-12.45,10-59.1,12.21-72.31c0.1-0.61,0.19-1.15,0.27-1.61
		c1.59-9.53-5.65-11.49-8.7-11.89c-0.79-0.11-1.3-0.11-1.3-0.11l-289.04-9.76c-0.57-1.39-1.26-2.78-2.11-4.14l286.15,9.9
		c0,0,7.46-0.64,13.32,2.33c0.39,0.19,0.81,0.41,1.24,0.67c0.18,0.11,0.35,0.21,0.52,0.33C736.26,742.7,738.75,746.86,737.63,753.93
		z"
            />
            <path
              class="green"
              d="M427.5,749.22c-1.37,0.5-2.51,1.62-3.18,3.08c-0.01,0.01-0.01,0.01-0.01,0.01c-0.31,0.65-0.52,1.38-0.61,2.15
		c-2.99-0.85-5.07-2.78-5.07-5.03c0-3.04,3.81-5.5,8.5-5.5c0.33,0,0.66,0.01,0.99,0.04C428.47,746.26,428.11,747.97,427.5,749.22z"
            />
            <path
              class="green"
              d="M732.63,752.93c-0.08,0.46-0.17,1-0.27,1.61c-2.21,13.21-10.1,59.86-12.21,72.31
		c-0.33,1.97-0.52,3.08-0.52,3.08s-3,12-15,13l-21.59-0.7h-0.01l-41.98-1.35l-32.59-1.05l-71.11-2.3l-34.79-1.12h-0.02l-33.34-1.07
		h-0.01l-1.68-0.06l-25.37-0.82l-47.51-1.53c0,0-9.33,0-12.85-4.47v-0.01c-1.5-1.91-1.94-4.64-0.15-8.52c6-13,31-81,31-81
		s2.11-5.62,9.26-7.44c0.59,0.76,1.18,1.56,1.74,2.41c0.91,1.36,1.66,2.62,2.27,3.8c1.28,2.46,1.95,4.54,2.22,6.27
		c0.35,2.29-0.01,4-0.62,5.25c-1.1,2.23-3.01,3.02-3.18,3.08c-0.01,0.01-0.01,0.01-0.01,0.01c-0.31,0.65-0.52,1.38-0.61,2.15
		c1.05,0.3,2.21,0.47,3.43,0.47c2.86,0,5.4-0.92,6.94-2.33c0.98-0.89,1.56-1.99,1.56-3.17c0,0,1.07-5.69-0.33-12.58
		c-0.37-1.84-0.92-3.76-1.71-5.68l289.04,9.76c0,0,0.51,0,1.3,0.11C726.98,741.44,734.22,743.4,732.63,752.93z"
            />
            <path
              class="green"
              d="M435.63,749.43c0,1.18-0.58,2.28-1.56,3.17c-1.54,1.41-4.08,2.33-6.94,2.33c-1.22,0-2.38-0.17-3.43-0.47
		c0.09-0.77,0.3-1.5,0.61-2.15c0,0,0,0,0.01-0.01c0.17-0.06,2.08-0.85,3.18-3.08c0.61-1.25,0.97-2.96,0.62-5.25
		c-0.27-1.73-0.94-3.81-2.22-6.27c-0.61-1.18-1.36-2.44-2.27-3.8c-0.56-0.85-1.15-1.65-1.74-2.41c-1.05-1.34-2.13-2.54-3.25-3.61
		c-1.68-1.62-3.42-2.92-5.17-3.9c-2.01-1.13-4.02-1.81-5.94-2.02c-2.09-0.23-4.07,0.1-5.81,1.05c-2.88,1.56-5.11,4.79-6.13,9.87
		c-3.04,3.76-7.01,7.3-11.62,10.57c-0.41-15.2,3.2-31.52,20.89-30.39c0.14,0.01,0.27,0.02,0.41,0.03c0.44,0.04,0.9,0.08,1.36,0.14
		c0.24,0.03,0.47,0.06,0.7,0.09c3.38,0.46,6.36,1.17,9,2.1h0.01c7.52,2.63,12.22,6.94,15.14,11.61c0.85,1.36,1.54,2.75,2.11,4.14
		c0.79,1.92,1.34,3.84,1.71,5.68C436.7,743.74,435.63,749.43,435.63,749.43z"
            />
            <path
              class="green"
              d="M401.72,723.01l-6.13,9.87C396.61,727.8,398.84,724.57,401.72,723.01z"
            />
            <path
              class="green"
              d="M416.34,715.42h-0.01c-2.64-0.93-5.62-1.64-9-2.1c-0.23-0.03-0.46-0.06-0.7-0.09
		c-0.46-0.06-0.92-0.1-1.36-0.14c0.25-1.04,0.49-2.25,0.65-3.59c0.57-4.71,0.19-10.96-3.73-16.84c0-0.01-0.01-0.01-0.01-0.01
		c-3.38-5.07-9.4-9.86-19.71-13.14c-3.19-1.02-6.78-1.89-10.84-2.58l2.35-1.41l7.65-4.59c0,0,33,9,35,39
		C416.75,711.74,416.65,713.57,416.34,715.42z"
            />
            <path
              class="green"
              d="M413.47,723.98c-1.44,2.94-3.34,5.87-5.64,8.77c-0.01,0.01-0.01,0.02-0.02,0.04
		c-1.39,1.75-2.92,3.48-4.59,5.19c-5.09,5.23-11.41,10.23-18.55,14.73c-21.11,13.32-49.4,22.3-74.57,20.22
		c-40.2-3.32-53.94-17.64-51.75-36.69c0-0.02,0.01-0.04,0.01-0.06c0.45-3.91,1.57-8.01,3.27-12.25
		c9.23-23.06,58.45-61.45,112.35-48.41l-2.35,1.41l2.62,5.32c-10.58-2.38-23.69-3.81-38.62-2.32c-2.11,0.21-4.2,0.51-6.27,0.9
		c-25.8,4.83-48.2,22.87-57.02,41.09c-3.9,8.05-5.15,16.14-2.88,23.14c0.36,1.12,0.78,2.19,1.25,3.2v0.01
		c9.57,20.73,39.39,18.97,39.39,18.97c18.73,0.55,52.87-8.84,73.87-23.79c4.61-3.27,8.58-6.81,11.62-10.57
		c0.52-0.65,1.02-1.29,1.48-1.95c1.88-2.65,3.43-5.3,4.65-7.92c1.74-0.95,3.72-1.28,5.81-1.05
		C409.45,722.17,411.46,722.85,413.47,723.98z"
            />
            <path
              class="green"
              d="M325.59,686.81c-2.62,5.32-4.02,10.98-4.09,11.93c0,0-48.79,6.53-50.79,49.52c-0.47-1.01-0.89-2.08-1.25-3.2
		c-2.27-7-1.02-15.09,2.88-23.14C280.42,711.99,297.43,695.31,325.59,686.81z"
            />
            <path
              class="green"
              d="M405.16,707.99c-8.98-16.4-38.24-30.33-69.53-23.75c-3.49,0.73-6.84,1.6-10.04,2.57
		c-28.16,8.5-45.17,25.18-53.25,35.11c8.82-18.22,31.22-36.26,57.02-41.09c2.07-0.39,4.16-0.69,6.27-0.9
		c14.93-1.49,28.04-0.06,38.62,2.32l0.16,0.32c1.47,0.22,2.89,0.47,4.25,0.76c0.02,0,0.03,0,0.04,0.01c3.9,1.04,7.39,2.18,10.41,3.3
		C399.56,691.34,404.8,698.99,405.16,707.99z"
            />
            <path
              class="green"
              d="M405.92,709.5c-0.16,1.34-0.4,2.55-0.65,3.59c-0.14-0.01-0.27-0.02-0.41-0.03c0.27-1.73,0.37-3.42,0.3-5.07
		c-0.36-9-5.6-16.65-16.05-21.35c-3.03-1.37-6.49-2.48-10.41-3.3c-0.01-0.01-0.02-0.01-0.04-0.01c-1.36-0.29-2.78-0.54-4.25-0.76
		l-0.16-0.32l-2.62-5.32c4.06,0.69,7.65,1.56,10.84,2.58c10.31,3.28,16.33,8.07,19.71,13.14c0,0,0.01,0,0.01,0.01
		C406.11,698.54,406.49,704.79,405.92,709.5z"
            />
            <path
              class="green"
              d="M403.22,737.98c-0.33,0.84-0.85,2.16-1.53,3.87c0,0,0,0,0,0.01l-0.01,0.01c-4.29,5.03-9.93,9.91-16.53,14.41
		c-23.31,15.91-58.39,26.96-86.7,22.15c-23.17-3.93-33.86-14.11-38.79-22.9c-0.01-0.02-0.02-0.03-0.02-0.05
		c-2.79-8.58-1.85-16.26-1.29-19.24c-2.19,19.05,11.55,33.37,51.75,36.69c25.17,2.08,53.46-6.9,74.57-20.22
		C391.81,748.21,398.13,743.21,403.22,737.98z"
            />
            <path
              class="green"
              d="M401.68,741.87c-1.32,3.38-3.23,8.28-5.47,14.05c-2.25,2.3-4.73,4.47-7.4,6.51c-0.74,0.57-1.49,1.13-2.26,1.67
		c-30.25,21.49-81.82,27.38-104.92,15.83c-13.06-6.53-19.2-15.9-21.97-24.4c4.93,8.79,15.62,18.97,38.79,22.9
		c28.31,4.81,63.39-6.24,86.7-22.15C391.75,751.78,397.39,746.9,401.68,741.87z"
            />
            <path class="green" d="M383.97,743.45" />
            <path
              class="green"
              d="M396.21,755.92c-1.11,2.87-2.31,5.95-3.55,9.17c-1.91-1.04-3.11-1.95-3.85-2.66
		C391.48,760.39,393.96,758.22,396.21,755.92z"
            />
            <g className="texts">
              <g>
                <path
                  d="M640.07,801.02c-0.78-1.99,0.04-3.63,1.81-4.7c1.4-0.84,3.52-1.42,4.96-0.34c1.47,1.1,1.13,3.2,3.01,4.05
				c1.35,0.61,4.52,0.73,4.2-1.55c-0.27-1.95-3.63-3.12-5.11-3.99c-1.77-1.04-3.97-2.38-4.98-4.22c-2.03-3.69,1.65-7.38,4.94-8.59
				c4.12-1.52,9.24-1.58,13.03,0.78c1.1,0.69,1.86,3.76,1.07,6.53c-0.02,1.14-0.56,1.2-1.61,1.56c-0.84,0.29-2.04,0.49-2.85,0
				c-0.79-0.47-1.04-1.59-1.44-2.34c-0.46-0.87-1.09-1.62-2.09-1.89c-1.46-0.39-3.86,0.88-3.15,2.64c0.42,1.03,2.05,1.74,2.95,2.32
				c1.11,0.71,2.25,1.35,3.38,2.02c2.16,1.28,4.19,3.01,3.95,5.75c-0.46,5.24-6.16,7.41-10.7,7.69
				C649,807,641.74,805.29,640.07,801.02z"
                />
                <path
                  d="M522.4,798.63c-0.95,0-1.9-0.01-2.84,0c-0.98,0.01-1.18,0.08-1.57,0.98c-0.68,1.59-0.89,2.52-2.77,2.86
				c-1.38,0.25-3.46,0.26-4.81-0.19c-1.54-0.52-1.01-1.88-0.74-3.14c1.31-6.17,3.17-13.03,7.85-17.6c3.89-3.8,11.13-6.79,15.79-2.48
				c5.1,4.72,3.36,12.76,1.95,18.64c-0.34,1.43-0.5,3.88-1.82,4.81c-1.22,0.86-3.67,0.4-5.08,0.36c-0.67-0.02-1.51,0.09-1.94-0.54
				c-0.42-0.61-0.13-1.69-0.08-2.36c0.06-0.82,0.33-1.27-0.57-1.39c-1.07-0.15-2.28,0-3.36,0C522.4,798.6,522.4,798.61,522.4,798.63
				z M527.1,792.96c0.46-2.03,0.72-4.03,0.44-6.07c-0.14-1.07-0.77-2.54-2.05-2.53c-1.07,0.01-2,1-2.61,1.76
				c-1.61,2.03-2.68,4.37-3.41,6.84C522.05,792.96,524.57,792.96,527.1,792.96z"
                />
                <path
                  d="M601.15,796.69c0.99,0.78,2.01,1.3,3.14,1.86c1.13,0.55,2.75,0.97,3.72,1.76c1.43,1.17-0.32,3.46-1.47,4.19
				c-1.83,1.17-4.17,0.65-6.01-0.22c-2.34-1.11-3.85-3.31-5.77-4.96c-0.23,1.68-0.18,5.26-2.31,5.64c-1.21,0.22-2.69,0.05-3.91-0.03
				c-0.99-0.07-1.78-0.27-1.88-1.38c-0.1-1.16,0.3-2.55,0.5-3.7c0.24-1.41,0.51-2.81,0.78-4.22c0.54-2.85,1.09-5.7,1.7-8.54
				c0.28-1.3,0.59-2.59,0.91-3.88c0.24-0.98,0.32-2.45,1.01-3.25c0.65-0.76,1.79-0.6,2.69-0.6c1.38,0,2.76,0.04,4.13,0.12
				c4.33,0.26,11.07,1.66,11.91,6.79c0.91,5.55-4.11,9.46-9.05,10.28C601.21,796.6,601.18,796.65,601.15,796.69z M597.3,792.23
				c1.78,0.04,4.07-0.91,4.92-2.55c0.92-1.78-0.07-3.27-1.81-3.93c-0.5-0.19-2.02-0.66-2.54-0.34c-0.59,0.36-0.61,2.28-0.73,2.88
				c-0.2,1-0.77,2.37-0.7,3.36C596.48,792.3,596.6,792.23,597.3,792.23z"
                />
                <path
                  d="M639.03,790.44c0.12,5.56-3.61,10.84-8.35,13.53c-4.58,2.6-10.8,2.99-14.97-0.67c-4.24-3.72-3.96-10.14-1.46-14.74
				c2.45-4.52,7.44-8.07,12.64-8.51c5.44-0.47,10.87,2.63,11.91,8.2C638.94,789,638.96,789.76,639.03,790.44z M627.47,786.42
				c-1.38-0.04-2.52,0.55-3.52,1.42c-2.11,1.83-3.52,4.97-3.14,7.77c0.36,2.69,2.49,5.08,5.38,4.14c2.71-0.88,4.8-3.97,5.24-6.66
				C631.85,790.55,630.77,786.2,627.47,786.42z"
                />
                <path
                  d="M549.68,795.9c2.36-3.39,4.06-7.01,5.86-10.7c1.41-2.9,3.02-7.15,6.83-7.19c0.9-0.01,1.8,0.03,2.7,0.07
				c0.82,0.03,1.99-0.11,2.71,0.35c1.28,0.82-0.97,3.16-1.54,4.03c-2.38,3.67-4.81,7.31-7.12,11.02c-1.16,1.86-2.24,3.78-3.3,5.7
				c-0.84,1.53-1.61,3.49-3.33,4.24c-1.68,0.73-4.36,0.31-6.18,0.27c-1.68-0.04-3.95-0.22-4.59-2.07c-0.63-1.82-0.33-4.16-0.48-6.06
				c-0.16-2.06-0.45-4.1-0.77-6.14c-0.34-2.11-0.79-4.18-1.23-6.27c-0.31-1.45-0.98-3.78,0.34-4.95c1.32-1.18,4.28-0.74,5.91-0.67
				c1.79,0.08,2.37,1.49,2.68,3.09c0.45,2.35,0.39,4.86,0.53,7.24c0.14,2.45,0.42,4.86,0.73,7.29
				C549.45,795.37,549.56,795.57,549.68,795.9z"
                />
                <path
                  d="M579.16,778.47c2.23,0,4.54-0.17,6.76,0.09c1.98,0.23,2.72,1.18,2.38,3.18c-0.85,4.93-6.91,2.25-10.28,2.79
				c-0.75,0.12-1.32,0.36-1.66,1.07c-0.32,0.67-0.81,2.32-0.74,3.05c0.14,1.33,4.08,1.02,5.15,1.1c0.54,0.04,1.43-0.05,1.77,0.47
				c0.4,0.6-0.05,2.02-0.17,2.66c-0.38,2.07-1.69,2.02-3.57,1.92c-1-0.05-2-0.12-3-0.13c-1.05,0-1.3,0.23-1.54,1.22
				c-0.14,0.58-0.66,1.79-0.39,2.37c0.3,0.64,1.57,0.41,2.16,0.42c2.3,0.05,4.73-0.13,7.01,0.17c2.08,0.27,1.43,2.08,0.96,3.54
				c-0.26,0.83-0.44,1.75-1.37,2.05c-0.99,0.32-2.27,0.13-3.29,0.13c-2.27,0-4.55-0.05-6.82-0.13c-1.85-0.07-4.28,0.12-6.02-0.63
				c-1.57-0.68-0.7-2.77-0.46-4.02c0.98-5.14,1.88-10.31,3-15.42c0.39-1.77,0.58-5.13,2.72-5.75c1.1-0.32,2.53-0.06,3.67-0.05
				c1.24,0.01,2.48,0.01,3.73,0.01C579.16,778.53,579.16,778.5,579.16,778.47z"
                />
                <path
                  d="M499.71,795.47c1.33,0.09,2.66,0.09,4,0.13c0.97,0.03,2.68-0.25,3.4,0.58c0.63,0.71,0.25,1.94,0.05,2.75
				c-0.31,1.25-0.63,2.44-2,2.85c-2.51,0.77-5.73,0.27-8.32,0.19c-1.83-0.06-6.47,0.59-7.23-1.71c-0.35-1.05,0.04-2.54,0.19-3.61
				c0.23-1.65,0.59-3.29,0.91-4.93c0.6-3.03,1.21-6.06,1.82-9.08c0.3-1.48,0.52-2.98,0.89-4.44c0.23-0.92,0.47-1.8,1.48-2.09
				c1.19-0.34,2.74-0.04,3.96,0.01c0.95,0.04,2.86-0.25,3.65,0.43c0.83,0.72,0.13,2.61-0.02,3.49c-0.28,1.63-0.59,3.26-0.89,4.89
				c-0.62,3.34-1.26,6.69-1.84,10.04C499.74,795.12,499.73,795.27,499.71,795.47z"
                />
                <path
                  d="M478.71,794.47c1.33,0.09,2.66,0.09,4,0.13c0.97,0.03,2.68-0.25,3.4,0.58c0.63,0.71,0.25,1.94,0.05,2.75
				c-0.31,1.25-0.63,2.44-2,2.85c-2.51,0.77-5.73,0.27-8.32,0.19c-1.83-0.06-6.47,0.59-7.23-1.71c-0.35-1.05,0.04-2.54,0.19-3.61
				c0.23-1.65,0.59-3.29,0.91-4.93c0.6-3.03,1.21-6.06,1.82-9.08c0.3-1.48,0.52-2.98,0.89-4.44c0.23-0.92,0.47-1.8,1.48-2.09
				c1.19-0.34,2.74-0.04,3.96,0.01c0.95,0.04,2.86-0.25,3.65,0.43c0.83,0.72,0.13,2.61-0.02,3.49c-0.28,1.63-0.59,3.26-0.89,4.89
				c-0.62,3.34-1.26,6.69-1.84,10.04C478.74,794.12,478.73,794.27,478.71,794.47z"
                />
              </g>
            </g>
          </g>
        </Link>
      </svg>

      <Link to="/products" className="button--violet">
        Quiero ver todo
      </Link>
    </div>
  );
};

export default Categories;
